/** @format */

import React from "react";

import { SvgIconCus } from "components";
import { ISVGIcon } from "types";

export const Icons = {
  Email: () => (
    <svg width="25"
      height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z" fill="#f2f2f2"></path> </g></svg>
  ),
  Start: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M1.16651 7.33008L16.1665 7.33008M16.1665 7.33008L10.3332 1.08008M16.1665 7.33008L10.3332 13.5801"
        stroke={color ?? "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Api: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M1.78174 18.3333C3.22261 15.8425 5.91571 14.1666 9.00022 14.1666C12.0847 14.1666 14.7778 15.8425 16.2187 18.3333"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.66699 10.4166C5.66699 9.72627 5.10735 9.16663 4.41699 9.16663C3.72664 9.16663 3.16699 9.72627 3.16699 10.4166C3.16699 11.107 3.72664 11.6666 4.41699 11.6666C5.10735 11.6666 5.66699 11.107 5.66699 10.4166Z"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
      <path
        d="M14.8335 10.4166C14.8335 9.72627 14.2739 9.16663 13.5835 9.16663C12.8931 9.16663 12.3335 9.72627 12.3335 10.4166C12.3335 11.107 12.8931 11.6666 13.5835 11.6666C14.2739 11.6666 14.8335 11.107 14.8335 10.4166Z"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
      <path
        d="M2.125 1.66663L2.53101 4.9147C2.65612 5.91555 3.50692 6.66663 4.51556 6.66663L13.4844 6.66663C14.4931 6.66663 15.3439 5.91555 15.469 4.9147L15.875 1.66663"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Star: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M9.11378 1.65332C9.48042 0.909427 10.5411 0.909426 10.9077 1.65332L12.6181 5.12365C12.7638 5.41921 13.0457 5.62404 13.3718 5.67125L17.167 6.22066C17.9863 6.33926 18.3149 7.3451 17.7236 7.92454L14.9626 10.6304C14.7285 10.8599 14.6217 11.1896 14.6768 11.5128L15.328 15.3302C15.4676 16.1483 14.6074 16.7706 13.8741 16.382L10.4789 14.5832C10.1861 14.4281 9.83543 14.4281 9.5426 14.5832L6.14743 16.382C5.4141 16.7706 4.55396 16.1483 4.69351 15.3302L5.34446 11.5142C5.39973 11.1902 5.29226 10.8598 5.05699 10.6303L2.28502 7.92616C1.69153 7.34719 2.01989 6.33899 2.84051 6.22059L6.64936 5.67104C6.97566 5.62397 7.25779 5.41909 7.40354 5.12338L9.11378 1.65332Z"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  BodyShape: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <g clipPath="url(#clip0_1685_22678)">
        <path
          d="M6.95496 3.49023C6.91031 3.4893 6.86566 3.4893 6.81589 3.48977C6.82612 3.46884 6.83635 3.4493 6.84659 3.4293C7.20008 2.75581 7.21124 1.9814 6.87682 1.30372C6.5424 0.626047 5.92054 0.163256 5.16984 0.0334884C5.15449 0.0306977 5.13635 0.0237209 5.11728 0.0162791C5.10612 0.012093 5.09496 0.00744186 5.0838 0.00372093L5.0731 0H4.49077L4.47915 0.00418605C4.38705 0.0381395 4.29077 0.0688372 4.19728 0.0986046C3.98891 0.165116 3.7731 0.233953 3.58194 0.345581C2.51542 0.968372 2.13589 2.32279 2.71821 3.42884L2.7424 3.47535C2.69635 3.48047 2.65077 3.48465 2.60519 3.4893C2.43728 3.50605 2.2638 3.52326 2.09635 3.55907C0.892168 3.81954 0.012633 4.90186 0.00472604 6.13349C-0.00271582 7.28093 7.48777e-05 8.42372 0.00333069 9.69163C0.00472604 10.227 0.232168 10.7116 0.627052 11.0214C1.0238 11.3326 1.5517 11.4386 2.07542 11.3121C2.08194 11.3107 2.08891 11.3093 2.09589 11.3079V16.1981C2.09589 17.1721 2.53403 17.7381 3.47356 17.9791L3.47635 17.9809C3.48101 17.9842 3.48519 17.9874 3.48984 17.9902L3.50659 18.0005H3.95821L4.78752 17.6726L5.60612 18.0005H6.04845L6.05822 17.9977C6.09775 17.9856 6.13775 17.9749 6.17775 17.9637C6.26612 17.9395 6.35775 17.9144 6.44519 17.8786C7.07496 17.6214 7.46705 17.0247 7.46798 16.3205C7.46938 15.1674 7.46938 14.014 7.46891 12.8609V11.3135L7.47217 11.314C7.52705 11.3242 7.57822 11.3335 7.62891 11.3428C8.10798 11.4298 8.59822 11.3023 8.97356 10.9926C9.33915 10.6912 9.5517 10.2488 9.55729 9.77953C9.57449 8.2907 9.57403 7.14465 9.55589 6.06326C9.5331 4.69488 8.3424 3.51674 6.95496 3.49023ZM3.63124 2.33023C3.63263 2.02465 3.75449 1.73721 3.97356 1.52047C4.1917 1.30512 4.47868 1.18698 4.78333 1.18698C4.78519 1.18698 4.78705 1.18698 4.78938 1.18698C5.42287 1.19023 5.93589 1.70977 5.93263 2.34512C5.93124 2.6507 5.80938 2.93814 5.59031 3.15488C5.37217 3.37023 5.08473 3.48837 4.78054 3.48837C4.77868 3.48837 4.77682 3.48837 4.77449 3.48837C4.14101 3.48512 3.62798 2.96558 3.63124 2.33023ZM7.46705 6.97116C7.46612 6.7493 7.36101 6.54977 7.18566 6.43721C7.02054 6.33116 6.82101 6.3186 6.63868 6.40139C6.40054 6.50977 6.28054 6.7107 6.28101 6.99907C6.28287 7.79116 6.2824 8.59674 6.2824 9.37535V11.6544V12.9386C6.2824 14.0623 6.2824 15.186 6.28147 16.3098C6.28147 16.4935 6.20519 16.6507 6.07217 16.7414C5.95449 16.8219 5.80659 16.8363 5.66566 16.7809C5.47589 16.707 5.37589 16.5428 5.37542 16.3065C5.37496 15.5698 5.37496 14.8335 5.37542 14.0967V13.2377C5.37542 13.1344 5.37542 13.0312 5.37542 12.9279C5.37542 12.6921 5.37635 12.4484 5.37449 12.2084C5.3717 11.8456 5.12287 11.5823 4.78287 11.5814H4.78194C4.61775 11.5814 4.46752 11.6447 4.35868 11.76C4.25031 11.8749 4.19031 12.0335 4.18984 12.2074C4.18891 12.8865 4.18891 13.5656 4.18891 14.2451C4.18891 14.9144 4.18891 15.5837 4.18798 16.253C4.18798 16.3279 4.18473 16.4144 4.1624 16.4907C4.10194 16.6981 3.90473 16.8335 3.6931 16.8121C3.47821 16.7902 3.30194 16.6098 3.2838 16.3926C3.28008 16.3498 3.28101 16.306 3.28147 16.26C3.28147 16.2423 3.28194 16.2247 3.28194 16.207V14.3167C3.28194 11.9014 3.28194 9.48558 3.28194 7.07023V7.0307C3.28287 6.96558 3.28333 6.89814 3.27031 6.83116C3.21542 6.55209 2.96566 6.3493 2.68891 6.3493C2.6717 6.3493 2.65449 6.35023 2.63728 6.35163C2.32566 6.38047 2.09868 6.63302 2.09775 6.95209C2.09589 7.46605 2.09589 7.98046 2.09589 8.49442C2.09589 8.87535 2.09589 9.25674 2.09542 9.63767C2.09542 9.70698 2.09263 9.78791 2.07217 9.8586C2.01124 10.0712 1.8038 10.2112 1.59077 10.1837C1.36938 10.1553 1.20194 9.97581 1.19217 9.75628C1.18612 9.61442 1.18705 9.4693 1.18845 9.32837C1.18891 9.26837 1.18938 9.20884 1.18938 9.14884V8.38558C1.18938 7.67535 1.18891 6.96465 1.18938 6.25442C1.19031 5.31023 1.82798 4.67535 2.77635 4.67488C4.11356 4.67395 5.45031 4.67395 6.78705 4.67488C7.73589 4.67535 8.37449 5.30977 8.37543 6.25302C8.37682 7.58046 8.37682 8.67209 8.37543 9.68791C8.37543 9.87163 8.29217 10.034 8.15403 10.1223C8.03124 10.2009 7.88101 10.2093 7.7424 10.1456C7.55775 10.0605 7.46798 9.91209 7.46845 9.69116V9.6307C7.46984 8.75907 7.47124 7.85721 7.46798 6.9707L7.46705 6.97116Z"
          fill="#3E227C"
        />
        <path
          d="M16.5442 0.772558C16.5442 0.508372 16.4958 0.182326 16.1154 0.00651163L16.1014 0H8.80884L8.79163 0.0111628C8.78373 0.0162791 8.77628 0.0213953 8.76838 0.0265116C8.75396 0.0362791 8.74047 0.0451163 8.72745 0.052093C8.46326 0.188837 8.32745 0.456279 8.38931 0.717209C8.45628 1 8.69163 1.18372 8.98931 1.18512C9.47396 1.18698 9.96652 1.18651 10.4433 1.18651H11.1665V4.26326C11.1665 8.51256 11.167 12.9065 11.1619 17.2284C11.1619 17.4926 11.2098 17.8186 11.5907 17.994L11.6047 18.0005H16.1009L16.1149 17.994C16.4958 17.8177 16.5442 17.4921 16.5437 17.2284C16.5372 11.7688 16.5372 6.23256 16.5437 0.773023L16.5442 0.772558ZM12.8977 9.59395C13.0967 9.59488 13.3028 9.59581 13.5056 9.59163C13.8367 9.58465 14.0958 9.32465 14.0963 9.00046C14.0963 8.67395 13.8372 8.41395 13.5056 8.40884C13.2256 8.40465 12.9526 8.40558 12.6633 8.40651C12.5637 8.40651 12.4637 8.40698 12.3633 8.40744V7.50046C12.3916 7.50046 12.4205 7.50046 12.4484 7.50046C12.5637 7.50093 12.6726 7.50139 12.7842 7.49953C13.1358 7.49349 13.3944 7.24698 13.3986 6.91395C13.4028 6.57721 13.1363 6.31953 12.7786 6.31442C12.6712 6.31302 12.5642 6.31349 12.4526 6.31349C12.4237 6.31349 12.3944 6.31349 12.3651 6.31349V5.40651H12.58C12.8493 5.40651 13.1186 5.40651 13.3879 5.40605H13.4172C13.4861 5.40605 13.5572 5.40605 13.6279 5.3907C13.9177 5.32651 14.1186 5.0586 14.0949 4.76744C14.0702 4.46326 13.8219 4.2293 13.5172 4.22279C13.2726 4.21767 13.0242 4.2186 12.7842 4.21953C12.6791 4.21953 12.5749 4.22047 12.4693 4.22047H12.3609V3.31349H12.4349C12.5414 3.31349 12.6479 3.31395 12.754 3.31349C13.133 3.3107 13.3977 3.06698 13.3981 2.72093C13.3981 2.37442 13.134 2.1307 12.7544 2.12791C12.6516 2.12698 12.5488 2.12744 12.4428 2.12791H12.3628V1.19488H15.34V16.806H12.3609V15.8726H12.4335C12.5405 15.8726 12.647 15.873 12.754 15.8726C13.133 15.8698 13.3977 15.626 13.3977 15.28C13.3977 14.9335 13.1335 14.6898 12.754 14.687C12.6512 14.686 12.5479 14.6865 12.4419 14.687H12.3623V13.78C12.4628 13.78 12.5633 13.7805 12.6628 13.7809C12.9367 13.7823 13.2205 13.7833 13.4986 13.7781C13.7177 13.774 13.9116 13.6637 14.0172 13.4823C14.1195 13.307 14.1219 13.0926 14.0228 12.9098C13.9112 12.7033 13.7214 12.594 13.4744 12.594H12.3642V11.687C12.3907 11.687 12.4172 11.687 12.4437 11.687C12.553 11.687 12.6661 11.6879 12.7772 11.686C13.1344 11.6805 13.4009 11.4233 13.3972 11.087C13.3935 10.7586 13.1298 10.507 12.7833 10.5009C12.6721 10.4991 12.5628 10.4995 12.4474 10.5C12.4186 10.5 12.3893 10.5 12.36 10.5V9.59302H12.6307C12.72 9.59302 12.8079 9.59302 12.8963 9.59395H12.8977Z"
          fill="#3E227C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1685_22678">
          <rect width="16.5442" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  User: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M12.7502 5.41671C12.7502 7.60284 10.9779 9.37504 8.79183 9.37504C6.60573 9.37504 4.8335 7.60284 4.8335 5.41671C4.8335 3.23057 6.60573 1.45837 8.79183 1.45837C10.9779 1.45837 12.7502 3.23057 12.7502 5.41671Z"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
      <path
        d="M16.5 18.3334V17.6667C16.5 14.353 13.8137 11.6667 10.5 11.6667H7.5C4.18629 11.6667 1.5 14.353 1.5 17.6667V18.3334"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
    </svg>
  ),
  Close: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#EBE7FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L12 10.9393L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L13.0607 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L12 13.0607L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L10.9393 12L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z"
        fill="#21065D"
      />
    </svg>
  ),
  ArrowRight: ({
    width,
    height,
    size = 24,
    wrapColor,
    color = "#9A9A9E",
    viewBox = "0 0 24 24",
    ...props
  }: ISVGIcon) => (
    <SvgIconCus
      width={width}
      size={size}
      height={height}
      wrapColor={wrapColor}
      viewBox={viewBox}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303C9.17678 18.2374 9.17678 17.7626 9.46967 17.4697L14.9393 12L9.46967 6.53033C9.17678 6.23744 9.17678 5.76256 9.46967 5.46967Z"
        fill={color}
        {...props}
      />
    </SvgIconCus>
  ),
  ArrowDown: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4401_21665)">
        <path
          d="M10.5867 6.19305L7.99999 8.77971L5.41332 6.19305C5.15332 5.93305 4.73332 5.93305 4.47332 6.19305C4.21332 6.45305 4.21332 6.87305 4.47332 7.13305L7.53332 10.193C7.79332 10.453 8.21332 10.453 8.47332 10.193L11.5333 7.13305C11.7933 6.87305 11.7933 6.45305 11.5333 6.19305C11.2733 5.93971 10.8467 5.93305 10.5867 6.19305Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4401_21665">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  EyeHide: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.53009 2.46967C3.23719 2.17678 2.76232 2.17678 2.46943 2.46967C2.17653 2.76256 2.17653 3.23744 2.46943 3.53033L4.58578 5.64668C3.61207 6.32254 2.87547 7.12109 2.35985 7.90076C1.75793 8.81095 1.4165 9.75949 1.4165 10.5C1.4165 11.0782 1.62448 11.7725 1.98309 12.461C2.34869 13.163 2.8965 13.9092 3.63696 14.5927C5.12687 15.968 7.39085 17.0833 10.4998 17.0833C12.2959 17.0833 13.814 16.711 15.0659 16.1268L17.4694 18.5303C17.7623 18.8232 18.2372 18.8232 18.5301 18.5303C18.823 18.2374 18.823 17.7626 18.5301 17.4697L3.53009 2.46967ZM13.9229 14.9838L12.2057 13.2666C11.7098 13.5729 11.125 13.75 10.4998 13.75C8.70483 13.75 7.24976 12.2949 7.24976 10.5C7.24976 9.87478 7.42685 9.28992 7.73312 8.79403L5.66715 6.72806C4.74179 7.3217 4.06395 8.04327 3.61101 8.72817C3.10202 9.49782 2.9165 10.1583 2.9165 10.5C2.9165 10.7551 3.02103 11.2066 3.31346 11.7681C3.5989 12.3161 4.04068 12.924 4.65438 13.4905C5.8728 14.6152 7.77549 15.5833 10.4998 15.5833C11.8353 15.5833 12.9706 15.3507 13.9229 14.9838ZM8.85086 9.91177C8.78535 10.0955 8.74976 10.2934 8.74976 10.5C8.74976 11.4665 9.53326 12.25 10.4998 12.25C10.7064 12.25 10.9043 12.2144 11.088 12.1489L8.85086 9.91177ZM10.4998 5.41665C9.64208 5.41665 8.86806 5.51261 8.17314 5.67765C7.77014 5.77337 7.36585 5.52426 7.27014 5.12126C7.17442 4.71826 7.42353 4.31397 7.82653 4.21825C8.63884 4.02532 9.52936 3.91665 10.4998 3.91665C13.6088 3.91665 15.8728 5.03191 17.3627 6.40721C18.1032 7.09072 18.651 7.83698 19.0166 8.53895C19.3752 9.22747 19.5832 9.92172 19.5832 10.5C19.5832 11.5532 18.8904 13.0785 17.6007 14.3644C17.3074 14.6569 16.8325 14.6562 16.5401 14.3629C16.2476 14.0695 16.2483 13.5947 16.5416 13.3022C17.6598 12.1873 18.0832 11.0216 18.0832 10.5C18.0832 10.2449 17.9786 9.79332 17.6862 9.23185C17.4008 8.68381 16.959 8.07591 16.3453 7.50942C15.1269 6.38472 13.2242 5.41665 10.4998 5.41665Z"
        fill="#000"
      />
    </svg>
  ),
  Eye: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 12C2.75 11.6616 2.88577 11.0954 3.24331 10.409C3.59385 9.73591 4.13459 8.9926 4.88371 8.3011C6.37297 6.9264 8.69232 5.75 12 5.75C15.3077 5.75 17.627 6.9264 19.1163 8.3011C19.8654 8.9926 20.4061 9.73591 20.7567 10.409C21.1142 11.0954 21.25 11.6616 21.25 12C21.25 12.3384 21.1142 12.9046 20.7567 13.591C20.4061 14.2641 19.8654 15.0074 19.1163 15.6989C17.627 17.0736 15.3077 18.25 12 18.25C8.69232 18.25 6.37297 17.0736 4.88371 15.6989C4.13459 15.0074 3.59385 14.2641 3.24331 13.591C2.88577 12.9046 2.75 12.3384 2.75 12ZM12 4.25C8.30768 4.25 5.62703 5.5736 3.86629 7.1989C2.99041 8.0074 2.34365 8.88909 1.91294 9.71605C1.48923 10.5296 1.25 11.3384 1.25 12C1.25 12.6616 1.48923 13.4704 1.91294 14.284C2.34365 15.1109 2.99041 15.9926 3.86629 16.8011C5.62703 18.4264 8.30768 19.75 12 19.75C15.6923 19.75 18.373 18.4264 20.1337 16.8011C21.0096 15.9926 21.6564 15.1109 22.0871 14.284C22.5108 13.4704 22.75 12.6616 22.75 12C22.75 11.3384 22.5108 10.5296 22.0871 9.71605C21.6564 8.88909 21.0096 8.0074 20.1337 7.1989C18.373 5.5736 15.6923 4.25 12 4.25ZM9.7499 12C9.7499 10.7574 10.7573 9.75002 11.9999 9.75002C13.2425 9.75002 14.2499 10.7574 14.2499 12C14.2499 13.2427 13.2425 14.25 11.9999 14.25C10.7573 14.25 9.7499 13.2427 9.7499 12ZM11.9999 8.25002C9.92883 8.25002 8.2499 9.92896 8.2499 12C8.2499 14.0711 9.92883 15.75 11.9999 15.75C14.071 15.75 15.7499 14.0711 15.7499 12C15.7499 9.92896 14.071 8.25002 11.9999 8.25002Z"
        fill="#000"
      />
    </svg>
  ),
  GoogleIcon: () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.26 12.273C24.26 11.4221 24.1837 10.6039 24.0418 9.81848H12.74V14.4603H19.1982C18.92 15.9603 18.0745 17.2312 16.8036 18.0821V21.0931H20.6818C22.9509 19.004 24.26 15.9276 24.26 12.273Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.74 23.9999C15.98 23.9999 18.6964 22.9254 20.6819 21.0926L16.8037 18.0817C15.7291 18.8017 14.3546 19.2272 12.74 19.2272C9.61456 19.2272 6.96909 17.1163 6.02546 14.2799H2.01636V17.389C3.99091 21.3108 8.0491 23.9999 12.74 23.9999Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02546 14.2801C5.78546 13.5601 5.64909 12.791 5.64909 12.0001C5.64909 11.2092 5.78546 10.4401 6.02546 9.72006V6.61096H2.01636C1.20363 8.23097 0.73999 10.0637 0.73999 12.0001C0.73999 13.9364 1.20363 15.7692 2.01636 17.3892L6.02546 14.2801Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.74 4.77286C14.5018 4.77286 16.0837 5.37832 17.3273 6.56741L20.7691 3.12558C18.6909 1.18922 15.9746 0.00012207 12.74 0.00012207C8.0491 0.00012207 3.99091 2.68922 2.01636 6.61104L6.02546 9.72014C6.96909 6.88377 9.61455 4.77286 12.74 4.77286Z"
        fill="#EA4335"
      />
    </svg>
  ),
  UnCheckBox: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="17" height="17" rx="5.5" fill="white" />
      <rect x="1" y="1" width="17" height="17" rx="5.5" stroke="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6738 5.44714C14.9791 5.72703 14.9998 6.20146 14.7199 6.5068L8.3032 13.5068C8.16497 13.6576 7.97114 13.7454 7.76662 13.7498C7.56211 13.7543 7.36465 13.675 7.22 13.5303L4.30333 10.6137C4.01044 10.3208 4.01044 9.8459 4.30333 9.55301C4.59623 9.26011 5.0711 9.26011 5.36399 9.55301L7.72677 11.9158L13.6141 5.49321C13.894 5.18787 14.3685 5.16724 14.6738 5.44714Z"
        fill="white"
      />
    </svg>
  ),
  Checked: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="18" height="18" rx="6" fill="#21065D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6737 5.44714C14.9791 5.72703 14.9997 6.20146 14.7198 6.5068L8.30315 13.5068C8.16492 13.6576 7.97109 13.7454 7.76658 13.7498C7.56206 13.7543 7.3646 13.675 7.21995 13.5303L4.30329 10.6137C4.01039 10.3208 4.01039 9.8459 4.30329 9.55301C4.59618 9.26011 5.07105 9.26011 5.36395 9.55301L7.72673 11.9158L13.6141 5.49321C13.894 5.18787 14.3684 5.16724 14.6737 5.44714Z"
        fill="white"
      />
    </svg>
  ),
  List: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <path
        d="M2 6.5C1.17 6.5 0.5 7.17 0.5 8C0.5 8.83 1.17 9.5 2 9.5C2.83 9.5 3.5 8.83 3.5 8C3.5 7.17 2.83 6.5 2 6.5ZM2 0.5C1.17 0.5 0.5 1.17 0.5 2C0.5 2.83 1.17 3.5 2 3.5C2.83 3.5 3.5 2.83 3.5 2C3.5 1.17 2.83 0.5 2 0.5ZM2 12.5C1.17 12.5 0.5 13.18 0.5 14C0.5 14.82 1.18 15.5 2 15.5C2.82 15.5 3.5 14.82 3.5 14C3.5 13.18 2.83 12.5 2 12.5ZM6 15H18C18.55 15 19 14.55 19 14C19 13.45 18.55 13 18 13H6C5.45 13 5 13.45 5 14C5 14.55 5.45 15 6 15ZM6 9H18C18.55 9 19 8.55 19 8C19 7.45 18.55 7 18 7H6C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9ZM5 2C5 2.55 5.45 3 6 3H18C18.55 3 19 2.55 19 2C19 1.45 18.55 1 18 1H6C5.45 1 5 1.45 5 2Z"
        fill="#21065D"
      />
    </svg>
  ),
  Menu: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 18H3"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 14H3"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 10H3"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6H3"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Notification: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M7.02051 18C7.02051 18.625 7.09395 19.3497 7.74544 19.8021C8.39692 20.2546 9.19708 20.5 10.0205 20.5C10.8439 20.5 11.6441 20.2546 12.2956 19.8021C12.9471 19.3497 13.0205 18.625 13.0205 18"
        stroke="#3A3A3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.51946 8.5C3.51946 4.91015 6.42961 2 10.0195 2V0C5.32504 0 1.51946 3.80558 1.51946 8.5V11.6074C1.51946 12.295 1.29644 12.964 0.883891 13.5141L0.620824 13.8648C0.336017 14.2446 -0.140295 14.9809 0.0394786 15.8658C0.32105 17.2517 1.53111 17.721 2.44274 17.8851C3.19781 18.021 4.07554 18.0109 4.74867 18.0032C4.89215 18.0015 5.0264 18 5.14812 18H10.0195V16H5.14812C4.97806 16 4.8095 16.0016 4.64317 16.0032C3.97644 16.0095 3.34551 16.0155 2.79707 15.9168C2.11669 15.7943 2.0277 15.6006 2.00052 15.4728C2.00112 15.4643 2.00461 15.4405 2.02161 15.3965C2.0539 15.3129 2.1174 15.2027 2.22082 15.0648L2.48389 14.7141C3.15609 13.8178 3.51946 12.7277 3.51946 11.6074V8.5ZM2.00048 15.4765C2.00044 15.4765 2.00039 15.4758 2.00044 15.4743L2.00048 15.4765Z"
        fill="#3A3A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5203 8.5C16.5203 4.91015 13.6093 2 10.0195 2V0C14.7139 0 18.5203 3.80558 18.5203 8.5V11.6074C18.5203 12.295 18.7433 12.964 19.1558 13.5141L19.4189 13.8648C19.7037 14.2446 20.18 14.9809 20.0002 15.8658C19.7187 17.2517 18.5086 17.721 17.597 17.8851C16.8419 18.021 15.9642 18.0109 15.291 18.0032C15.1476 18.0015 15.0133 18 14.8916 18H10.0195V16H14.8916C15.0617 16 15.2302 16.0016 15.3966 16.0032C16.0633 16.0095 16.6942 16.0155 17.2426 15.9168C17.923 15.7943 18.012 15.6006 18.0392 15.4728C18.0386 15.4643 18.0351 15.4405 18.0181 15.3965C17.9858 15.3129 17.9223 15.2027 17.8189 15.0648L17.5558 14.7141C16.8836 13.8178 16.5203 12.7277 16.5203 11.6074V8.5ZM18.0392 15.4765C18.0393 15.4765 18.0393 15.4758 18.0393 15.4743L18.0392 15.4765Z"
        fill="#3A3A3C"
      />
    </svg>
  ),
  Home: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        d="M1 19V8.67412C1 8.04041 1.30033 7.4442 1.80954 7.067L8.80955 1.88182C9.51674 1.35797 10.4833 1.35797 11.1905 1.88182L18.1905 7.067C18.6997 7.4442 19 8.04041 19 8.67412V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19Z"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
      <path
        d="M6.5 21V14C6.5 13.1716 7.17157 12.5 8 12.5H12C12.8284 12.5 13.5 13.1716 13.5 14V21"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Setting: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M13.7462 10.9472C13.7462 12.4812 12.5188 13.7499 11 13.7499C9.48124 13.7499 8.24512 12.4812 8.24512 10.9472C8.24512 9.41318 9.48124 8.24988 11 8.24988C12.5188 8.24988 13.7462 9.41318 13.7462 10.9472Z"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
      />
      <path
        d="M13.2127 3.04115L12.5749 1.5962C12.4149 1.23381 12.0562 1 11.66 1H10.3151C9.91901 1 9.56023 1.23381 9.40028 1.5962L8.7625 3.04115C8.14903 4.43103 6.70895 5.26643 5.19788 5.10901L3.39332 4.92102C3.00234 4.88029 2.62377 5.07239 2.42579 5.41199L1.83283 6.42909C1.63099 6.77531 1.65534 7.2086 1.89471 7.53002L2.92975 8.91989C3.84991 10.1555 3.85394 11.8475 2.93967 13.0875L1.89016 14.5108C1.65335 14.832 1.63015 15.2632 1.83113 15.608L2.42295 16.6231C2.62238 16.9652 3.00486 17.1573 3.39835 17.1132L5.17891 16.9134C6.69885 16.7429 8.15349 17.5791 8.77109 18.9783L9.40028 20.4038C9.56023 20.7662 9.91901 21 10.3151 21H11.66C12.0562 21 12.4149 20.7662 12.5749 20.4038L13.2041 18.9783C13.8217 17.5791 15.2763 16.7429 16.7963 16.9134L18.5829 17.1139C18.9733 17.1577 19.3531 16.9688 19.5539 16.6312L20.1632 15.6064C20.3676 15.2627 20.3476 14.8304 20.1124 14.5071L19.0664 13.069C18.1701 11.8368 18.174 10.1661 19.0762 8.93811L20.1079 7.53379C20.3456 7.2102 20.3667 6.77581 20.1615 6.43068L19.5511 5.40395C19.3518 5.06875 18.9758 4.87998 18.5879 4.92039L16.7773 5.10901C15.2662 5.26643 13.8261 4.43103 13.2127 3.04115Z"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  Help: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
        stroke="#3E227C"
        strokeWidth="2"
      />
      <path
        d="M8.5 7.71806C8.63486 7.36247 8.83863 7.04373 9.09392 6.78019C9.56143 6.29757 10.2017 6 10.908 6C12.3395 6 13.5 7.22255 13.5 8.73065C13.5 10.0598 12.5986 11.1671 11.4047 11.4112C11.1342 11.4665 10.908 11.6852 10.908 11.9613V13"
        stroke="#3E227C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11 17.25C11.5523 17.25 12 16.8023 12 16.25C12 15.6977 11.5523 15.25 11 15.25C10.4477 15.25 10 15.6977 10 16.25C10 16.8023 10.4477 17.25 11 17.25Z"
        fill="#3E227C"
      />
    </svg>
  ),
  Logout: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 17L21 12L16 7"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H9"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Plus: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
      />
      <path
        d="M11 7V15"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11L7 11"
        stroke={color ?? "#3A3A3C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PlusWhite: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11 7V15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11L7 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Upload: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M1.08301 15.0942H16.9163"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.99971 10.6962V1.8999M8.99971 1.8999L4.60156 5.15779M8.99971 1.8999L13.3979 5.15779"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Edit: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.5 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V9.5"
        stroke="#3E227C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.6888 6.85937L10.3566 13.146C10.1225 13.3784 9.83456 13.5493 9.51841 13.6434L5.76128 14.7625C5.57411 14.8182 5.39816 14.6474 5.4483 14.4587L6.36383 11.0126C6.45307 10.6767 6.6283 10.3698 6.87226 10.1223L13.3642 3.53472M16.6888 6.85937L18.5055 5.04267C19.2866 4.26162 19.2866 2.99529 18.5055 2.21424L18.0093 1.71802C17.2283 0.93697 15.9619 0.936969 15.1809 1.71802L13.3642 3.53472M16.6888 6.85937L13.3642 3.53472"
        stroke="#3E227C"
        strokeWidth="2"
      />
    </svg>
  ),
  Delete: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M3.5 4L3.5 19C3.5 20.1046 4.39543 21 5.5 21H16.5C17.6046 21 18.5 20.1046 18.5 19V4"
        stroke="#5553BA"
        strokeWidth="2"
      />
      <path
        d="M9 10V15"
        stroke="#5553BA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 10V15"
        stroke="#5553BA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1.5 4H20.5"
        stroke="#5553BA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6 4L6.22147 2.6712C6.3822 1.70683 7.21658 1 8.19425 1H11H13.8057C14.7834 1 15.6178 1.70683 15.7785 2.6712L16 4"
        stroke="#5553BA"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  Back: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M19 9L1 9M1 9L8 1.5M1 9L8 16.5"
        stroke={color ?? "#7340D8"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Sparkers: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M0.5 12.4982C0.621001 12.5602 0.71096 12.6079 0.801552 12.6523C2.80662 13.6437 4.81105 14.6369 6.81929 15.6232C6.99287 15.7084 7.10184 15.8244 7.18673 15.9935C8.19148 17.9931 9.20257 19.9896 10.2118 21.9867C10.2498 22.0618 10.2909 22.1364 10.3442 22.2373C10.8383 21.2598 11.3172 20.3117 11.7968 19.3636C12.3758 18.2181 12.9517 17.072 13.539 15.9303C13.5941 15.8225 13.7005 15.7178 13.8095 15.6633C15.8462 14.6482 17.8874 13.6405 19.9273 12.631C20.0033 12.5934 20.0781 12.5521 20.1769 12.5001C20.0838 12.4499 20.0173 12.4117 19.9488 12.3779C17.9159 11.3728 15.8817 10.3702 13.8532 9.35689C13.7182 9.28984 13.5865 9.16075 13.5181 9.02791C12.4968 7.0277 11.4864 5.02185 10.4734 3.01725C10.4385 2.9477 10.4012 2.87939 10.3448 2.77287C10.2935 2.86561 10.2529 2.93328 10.2175 3.00347C9.20763 5.00054 8.19655 6.99699 7.19116 8.99658C7.10247 9.17266 6.98907 9.29172 6.80725 9.3807C4.79268 10.3702 2.78191 11.3684 0.769876 12.3647C0.692588 12.4029 0.615299 12.4418 0.5 12.4988L0.5 12.4982ZM10.3429 7.24389C10.3961 7.3454 10.436 7.41997 10.474 7.49579C10.9897 8.51469 11.5022 9.53548 12.0268 10.55C12.0857 10.664 12.1984 10.7731 12.3137 10.832C13.1348 11.2499 13.9634 11.6535 14.7889 12.0627C15.0689 12.2012 15.3483 12.3415 15.6574 12.4963C15.5611 12.5471 15.4933 12.5847 15.4243 12.6185C14.3942 13.1292 13.3616 13.6355 12.3366 14.1556C12.2079 14.2208 12.0819 14.3411 12.016 14.4677C11.4933 15.4747 10.9859 16.4892 10.474 17.5018C10.436 17.577 10.3967 17.651 10.3429 17.755C10.2916 17.6591 10.2536 17.5921 10.2187 17.5238C9.69924 16.4974 9.18356 15.4697 8.65584 14.4476C8.59693 14.3336 8.4848 14.2221 8.3695 14.1638C7.33687 13.6418 6.29791 13.1317 5.26085 12.6179C5.1918 12.5834 5.12401 12.5464 5.02962 12.4969C5.13478 12.4437 5.21017 12.4042 5.28682 12.3666C6.30298 11.864 7.3223 11.3665 8.33339 10.8533C8.46832 10.785 8.59883 10.6559 8.66788 10.5224C9.19496 9.50916 9.70621 8.48712 10.2225 7.46822C10.2574 7.39992 10.2947 7.33349 10.3429 7.24326V7.24389Z"
        fill="white"
      />
      <path
        d="M15.4102 4.49426C15.9328 4.75368 16.4105 4.99118 16.8888 5.22804C17.3405 5.45175 17.7966 5.66731 18.2413 5.90355C18.356 5.96434 18.4675 6.074 18.5264 6.18867C18.9629 7.02898 19.3854 7.87619 19.8131 8.72152C19.8511 8.79608 19.8929 8.86877 19.9493 8.97217C20.0044 8.87567 20.0487 8.80611 20.0855 8.73342C20.5137 7.88872 20.9357 7.04089 21.3728 6.2012C21.4355 6.08089 21.5521 5.96308 21.6737 5.90105C22.5226 5.46804 23.3791 5.05071 24.2331 4.62773C24.3078 4.59076 24.3801 4.54815 24.4821 4.493C24.382 4.43786 24.311 4.39462 24.2369 4.35765C23.3759 3.93154 22.5125 3.50982 21.6553 3.07619C21.5457 3.02105 21.4393 2.9164 21.3835 2.80862C20.9097 1.89123 20.4479 0.967574 19.9588 0.000680923C19.9024 0.100943 19.8612 0.167991 19.8257 0.238173C19.3943 1.08977 18.9686 1.94449 18.5277 2.79107C18.465 2.91139 18.3452 3.02543 18.2236 3.08747C17.3816 3.51671 16.5321 3.93154 15.6857 4.35139C15.6091 4.38961 15.5337 4.43034 15.4102 4.49426Z"
        fill="white"
      />
      <path
        d="M17.4336 20.5109C18.1856 20.8831 18.9002 21.2309 19.6084 21.5925C19.7111 21.6445 19.8099 21.7435 19.8631 21.845C20.1976 22.4823 20.5182 23.1265 20.8438 23.7681C20.8786 23.8364 20.9166 23.9029 20.9686 24C21.3341 23.2794 21.6769 22.5857 22.0392 21.9027C22.1096 21.7704 22.2382 21.6426 22.3718 21.5731C23.0624 21.2146 23.7637 20.8756 24.4998 20.5103C24.4003 20.4577 24.3351 20.4213 24.2679 20.3881C23.6401 20.0767 23.0142 19.7621 22.3826 19.4582C22.2185 19.3792 22.1077 19.2764 22.0266 19.1104C21.6864 18.4161 21.3316 17.7293 20.9667 17.0093C20.8717 17.1942 20.7887 17.3521 20.7082 17.5112C20.4396 18.0414 20.1666 18.5696 19.9068 19.1041C19.8276 19.2677 19.7218 19.3773 19.5552 19.4569C18.923 19.7596 18.2977 20.0748 17.6699 20.3862C17.6002 20.4207 17.5324 20.4583 17.4342 20.5097L17.4336 20.5109Z"
        fill="white"
      />
    </svg>
  ),
  Sparkers_2: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M0.5 12.4982C0.621001 12.5602 0.71096 12.6079 0.801552 12.6523C2.80662 13.6437 4.81105 14.6369 6.81929 15.6232C6.99287 15.7084 7.10184 15.8244 7.18673 15.9935C8.19148 17.9931 9.20257 19.9896 10.2118 21.9867C10.2498 22.0618 10.2909 22.1364 10.3442 22.2373C10.8383 21.2598 11.3172 20.3117 11.7968 19.3636C12.3758 18.2181 12.9517 17.072 13.539 15.9303C13.5941 15.8225 13.7005 15.7178 13.8095 15.6633C15.8462 14.6482 17.8874 13.6405 19.9273 12.631C20.0033 12.5934 20.0781 12.5521 20.1769 12.5001C20.0838 12.4499 20.0173 12.4117 19.9488 12.3779C17.9159 11.3728 15.8817 10.3702 13.8532 9.35689C13.7182 9.28984 13.5865 9.16075 13.5181 9.02791C12.4968 7.0277 11.4864 5.02185 10.4734 3.01725C10.4385 2.9477 10.4012 2.87939 10.3448 2.77287C10.2935 2.86561 10.2529 2.93328 10.2175 3.00347C9.20763 5.00054 8.19655 6.99699 7.19116 8.99658C7.10247 9.17266 6.98907 9.29172 6.80725 9.3807C4.79268 10.3702 2.78191 11.3684 0.769876 12.3647C0.692588 12.4029 0.615299 12.4418 0.5 12.4988L0.5 12.4982ZM10.3429 7.24389C10.3961 7.3454 10.436 7.41997 10.474 7.49579C10.9897 8.51469 11.5022 9.53548 12.0268 10.55C12.0857 10.664 12.1984 10.7731 12.3137 10.832C13.1348 11.2499 13.9634 11.6535 14.7889 12.0627C15.0689 12.2012 15.3483 12.3415 15.6574 12.4963C15.5611 12.5471 15.4933 12.5847 15.4243 12.6185C14.3942 13.1292 13.3616 13.6355 12.3366 14.1556C12.2079 14.2208 12.0819 14.3411 12.016 14.4677C11.4933 15.4747 10.9859 16.4892 10.474 17.5018C10.436 17.577 10.3967 17.651 10.3429 17.755C10.2916 17.6591 10.2536 17.5921 10.2187 17.5238C9.69924 16.4974 9.18356 15.4697 8.65584 14.4476C8.59693 14.3336 8.4848 14.2221 8.3695 14.1638C7.33687 13.6418 6.29791 13.1317 5.26085 12.6179C5.1918 12.5834 5.12401 12.5464 5.02962 12.4969C5.13478 12.4437 5.21017 12.4042 5.28682 12.3666C6.30298 11.864 7.3223 11.3665 8.33339 10.8533C8.46832 10.785 8.59883 10.6559 8.66788 10.5224C9.19496 9.50916 9.70621 8.48712 10.2225 7.46822C10.2574 7.39992 10.2947 7.33349 10.3429 7.24326V7.24389Z"
        fill="#B9B8FD"
      />
      <path
        d="M15.4102 4.49426C15.9328 4.75368 16.4105 4.99118 16.8888 5.22804C17.3405 5.45175 17.7966 5.66731 18.2413 5.90355C18.356 5.96434 18.4675 6.074 18.5264 6.18867C18.9629 7.02898 19.3854 7.87619 19.8131 8.72152C19.8511 8.79608 19.8929 8.86877 19.9493 8.97217C20.0044 8.87567 20.0487 8.80611 20.0855 8.73342C20.5137 7.88872 20.9357 7.04089 21.3728 6.2012C21.4355 6.08089 21.5521 5.96308 21.6737 5.90105C22.5226 5.46804 23.3791 5.05071 24.2331 4.62773C24.3078 4.59076 24.3801 4.54815 24.4821 4.493C24.382 4.43786 24.311 4.39462 24.2369 4.35765C23.3759 3.93154 22.5125 3.50982 21.6553 3.07619C21.5457 3.02105 21.4393 2.9164 21.3835 2.80862C20.9097 1.89123 20.4479 0.967574 19.9588 0.000680923C19.9024 0.100943 19.8612 0.167991 19.8257 0.238173C19.3943 1.08977 18.9686 1.94449 18.5277 2.79107C18.465 2.91139 18.3452 3.02543 18.2236 3.08747C17.3816 3.51671 16.5321 3.93154 15.6857 4.35139C15.6091 4.38961 15.5337 4.43034 15.4102 4.49426Z"
        fill="#B9B8FD"
      />
      <path
        d="M17.4336 20.5109C18.1856 20.8831 18.9002 21.2309 19.6084 21.5925C19.7111 21.6445 19.8099 21.7435 19.8631 21.845C20.1976 22.4823 20.5182 23.1265 20.8438 23.7681C20.8786 23.8364 20.9166 23.9029 20.9686 24C21.3341 23.2794 21.6769 22.5857 22.0392 21.9027C22.1096 21.7704 22.2382 21.6426 22.3718 21.5731C23.0624 21.2146 23.7637 20.8756 24.4998 20.5103C24.4003 20.4577 24.3351 20.4213 24.2679 20.3881C23.6401 20.0767 23.0142 19.7621 22.3826 19.4582C22.2185 19.3792 22.1077 19.2764 22.0266 19.1104C21.6864 18.4161 21.3316 17.7293 20.9667 17.0093C20.8717 17.1942 20.7887 17.3521 20.7082 17.5112C20.4396 18.0414 20.1666 18.5696 19.9068 19.1041C19.8276 19.2677 19.7218 19.3773 19.5552 19.4569C18.923 19.7596 18.2977 20.0748 17.6699 20.3862C17.6002 20.4207 17.5324 20.4583 17.4342 20.5097L17.4336 20.5109Z"
        fill="#B9B8FD"
      />
    </svg>
  ),
  Gallery: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.08301 16.4166V3.58325C2.08301 2.75482 2.75458 2.08325 3.58301 2.08325H7.18023C8.00866 2.08325 8.68023 2.75482 8.68023 3.58325V16.4166C8.68023 17.245 8.00866 17.9166 7.18023 17.9166H3.58301C2.75458 17.9166 2.08301 17.245 2.08301 16.4166Z"
        stroke="#9577D9"
        strokeWidth="2"
      />
      <path
        d="M11.3193 7.18048V3.58325C11.3193 2.75482 11.9909 2.08325 12.8193 2.08325H16.4166C17.245 2.08325 17.9166 2.75482 17.9166 3.58325V7.18047C17.9166 8.0089 17.245 8.68047 16.4166 8.68047H12.8193C11.9909 8.68047 11.3193 8.0089 11.3193 7.18048Z"
        stroke="#9577D9"
        strokeWidth="2"
      />
      <path
        d="M11.3193 16.4168V12.8196C11.3193 11.9912 11.9909 11.3196 12.8193 11.3196H16.4166C17.245 11.3196 17.9166 11.9912 17.9166 12.8196V16.4168C17.9166 17.2452 17.245 17.9168 16.4166 17.9168H12.8193C11.9909 17.9168 11.3193 17.2452 11.3193 16.4168Z"
        stroke="#9577D9"
        strokeWidth="2"
      />
    </svg>
  ),
  ArrowSelect: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M12.333 1.33341L7.70678 5.95964C7.31626 6.35017 6.68309 6.35016 6.29257 5.95964L1.66634 1.33341"
        stroke={color ?? "#2D76BB"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Should: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_957_6161)">
        <path
          d="M7.38024 0H8.66078C8.67413 0.0283437 8.70085 0.0287605 8.72631 0.0300109C9.20755 0.0591882 9.67836 0.152556 10.1412 0.282186C10.7143 0.442661 11.2698 0.647736 11.7849 0.952431C11.7786 1.02704 11.8045 1.0954 11.8229 1.16542C12.0963 2.21873 12.2027 3.28453 12.0675 4.36909C11.4101 4.16068 10.8771 4.34367 10.4088 4.84343C9.23426 6.09639 8.04222 7.33267 6.86144 8.57979C6.76126 8.68567 6.70867 8.70317 6.5989 8.58688C6.12308 8.0842 5.64393 7.58443 5.15183 7.09759C4.51824 6.47111 3.4656 6.60116 2.98728 7.35185C2.62081 7.92789 2.70846 8.61981 3.21976 9.14917C4.07623 10.0362 4.93521 10.9211 5.79293 11.8072C5.77373 11.8151 5.75495 11.8247 5.73492 11.8301C4.43518 12.179 3.12334 12.2303 1.80065 11.986C1.5256 11.9352 1.25305 11.8706 0.979242 11.8126C0.957121 11.778 0.932078 11.7451 0.913296 11.7089C0.0839534 10.117 -0.174825 8.42932 0.113588 6.66493C0.367357 5.11436 1.03726 3.75304 2.10284 2.5972C3.36835 1.22586 4.92352 0.383056 6.77086 0.0917001C6.97371 0.0596051 7.17698 0.0304278 7.38024 0Z"
          fill="#74D97F"
        />
        <path
          d="M12.0667 4.36954C12.202 3.28498 12.0955 2.21918 11.8222 1.16588C11.8038 1.09585 11.7779 1.02707 11.7842 0.952881C14.0798 2.2446 15.4576 4.18573 15.9079 6.78459C15.9422 6.98091 15.9296 7.18432 15.9993 7.37522V8.62526C15.9409 8.77073 15.9505 8.92704 15.9288 9.07834C15.7038 10.6598 15.0777 12.0619 14.0218 13.2599C12.7283 14.7271 11.1118 15.6153 9.17469 15.9138C8.98227 15.9433 8.78485 15.9363 8.59744 15.9996H7.37952C7.36282 15.9634 7.32818 15.9713 7.29854 15.9688C5.94288 15.8458 4.69616 15.4107 3.56588 14.6525C2.47233 13.9189 1.60543 12.9743 0.978516 11.8127C1.25232 11.871 1.52487 11.9352 1.79993 11.9861C3.12262 12.2303 4.43446 12.1791 5.73419 11.8302C5.75422 11.8248 5.77259 11.8152 5.79221 11.8073C6.46378 12.3545 7.31983 12.2391 7.90167 11.5838C8.52649 10.8802 9.1943 10.2146 9.84375 9.53226C10.7441 8.58608 11.6452 7.64115 12.5438 6.69372C12.9299 6.28691 13.0564 5.8084 12.8957 5.26904C12.7671 4.83846 12.4691 4.55294 12.0667 4.36913V4.36954Z"
          fill="#2AD252"
        />
        <path
          d="M12.0669 4.36955C12.4693 4.55337 12.7677 4.83889 12.8958 5.26946C13.0565 5.80882 12.9301 6.28733 12.544 6.69415C11.6449 7.64158 10.7442 8.5865 9.84392 9.53268C9.19489 10.215 8.52707 10.8807 7.90183 11.5843C7.32 12.2395 6.46394 12.355 5.79237 11.8077C4.93465 10.9219 4.07609 10.0366 3.2192 9.14962C2.7079 8.62027 2.61983 7.92835 2.98672 7.3523C3.46462 6.6012 4.51768 6.47157 5.15127 7.09804C5.64336 7.58447 6.12252 8.08424 6.59834 8.58734C6.70811 8.70363 6.7607 8.68612 6.86087 8.58025C8.04165 7.33313 9.2337 6.09685 10.4082 4.84389C10.8765 4.34412 11.4091 4.16156 12.0669 4.36955Z"
          fill="#FDFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_957_6161">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  NotShould: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_957_6185)">
        <path
          d="M7.40795 0.00476074H8.56409C8.58705 0.0459244 8.62782 0.0320713 8.66186 0.0344461C9.26071 0.0787762 9.85125 0.180894 10.4161 0.380379C13.5061 1.47201 15.3462 3.62993 15.9173 6.86287C15.9514 7.05483 15.9411 7.25273 16.0001 7.44074V8.59688C15.951 8.62934 15.9751 8.6804 15.968 8.72354C15.9466 8.8593 15.9557 8.99942 15.9098 9.13162C15.9114 9.04058 15.8865 8.96775 15.8164 8.8977C14.5554 7.64141 13.2975 6.38196 12.0385 5.1241C12.0001 5.0857 11.97 5.02792 11.8999 5.03821L11.9059 5.03939C11.9039 5.01921 11.8932 5.00733 11.873 5.00456L11.8758 5.00733C11.8647 4.99586 11.8536 4.98438 11.8425 4.9725L11.8461 4.97488C11.8346 4.9634 11.8231 4.95153 11.8117 4.94005L11.8136 4.94401C11.7673 4.82447 11.6822 4.74333 11.5659 4.69267C11.4281 4.55889 11.2888 4.42629 11.1527 4.29093C10.6975 3.83892 10.1501 3.83852 9.6957 4.29172C9.1764 4.81022 8.65552 5.32675 8.14098 5.8504C8.04915 5.94381 8.00205 5.95885 7.90152 5.85515C7.37668 5.31289 6.84472 4.77777 6.31117 4.24422C5.88568 3.81873 5.3276 3.82111 4.89894 4.24462C4.6951 4.44569 4.49364 4.64874 4.29178 4.85178C3.83819 5.30696 3.83739 5.85436 4.29019 6.30834C4.81939 6.83872 5.34739 7.37068 5.88212 7.89591C5.97236 7.98457 5.96286 8.03009 5.87856 8.11282C5.33393 8.65032 4.79247 9.19059 4.25457 9.73482C3.85085 10.1429 3.85204 10.7026 4.25061 11.113C4.40617 11.2729 4.56409 11.4308 4.72083 11.5896C4.61673 11.6778 4.74577 11.6984 4.77228 11.7253C6.12396 13.0841 7.48038 14.4382 8.83324 15.7962C8.9128 15.8757 8.99314 15.9209 9.10357 15.9133C9.07943 15.9216 9.05529 15.9339 9.03035 15.9371C7.65572 16.1033 6.32226 15.9418 5.03312 15.4312C1.41468 13.9988 -0.660132 10.0815 0.18966 6.28697C0.923086 3.01367 3.53698 0.586198 6.86134 0.0870881C7.04341 0.0597776 7.23102 0.0661104 7.40834 0.00476074H7.40795Z"
          fill="#F05249"
        />
        <path
          d="M15.9102 9.13164C15.7859 10.0962 15.4859 11.005 15.0086 11.8496C13.8077 13.9743 12.006 15.2959 9.62681 15.831C9.45503 15.8698 9.27811 15.8864 9.10356 15.9134C8.99313 15.9209 8.91278 15.8758 8.83322 15.7962C7.48036 14.4382 6.12394 13.0841 4.77227 11.7253C4.74575 11.6984 4.61632 11.6782 4.72081 11.59C4.75485 11.622 4.78929 11.6533 4.82254 11.6862C5.31492 12.1777 5.84054 12.1793 6.33332 11.6913C6.8542 11.1752 7.37468 10.659 7.89714 10.1445C7.93514 10.1069 7.96166 10.0448 8.0333 10.0558C8.04478 10.0729 8.05428 10.0919 8.06853 10.1061C8.62938 10.6638 9.18588 11.2254 9.75347 11.7764C10.1552 12.1663 10.6983 12.1588 11.1055 11.7697C11.3311 11.554 11.5508 11.3319 11.7681 11.1079C12.1865 10.6757 12.1829 10.1188 11.7602 9.69328C11.4815 9.41266 11.1997 9.1352 10.9175 8.85814C10.6361 8.58187 10.3523 8.30757 10.0693 8.03249C10.0626 7.96164 10.1243 7.93631 10.1623 7.89871C10.686 7.37783 11.2116 6.85853 11.7364 6.33845C11.8215 6.25414 11.9035 6.16706 11.9593 6.0598C12.1425 5.70793 12.0954 5.36912 11.8999 5.03942C11.97 5.02912 12.0001 5.08691 12.0384 5.12531C13.2979 6.38317 14.5554 7.64262 15.8164 8.89891C15.8869 8.96896 15.9114 9.04179 15.9098 9.13283L15.9102 9.13164Z"
          fill="#CE3D3A"
        />
        <path
          d="M11.8999 5.03822C12.0954 5.36792 12.1425 5.70713 11.9592 6.0586C11.9034 6.16586 11.8215 6.25334 11.7364 6.33725C11.2116 6.85694 10.6859 7.37623 10.1623 7.89751C10.1243 7.93551 10.0621 7.96084 10.0693 8.03169C10.0052 8.03525 9.96992 8.08433 9.92995 8.12391C9.32595 8.72593 8.72195 9.32795 8.11914 9.93076C8.08352 9.96638 8.03523 9.99527 8.03325 10.055C7.96161 10.044 7.93509 10.1061 7.8971 10.1437C7.37503 10.6582 6.85415 11.1744 6.33327 11.6905C5.8405 12.1789 5.31526 12.1773 4.82249 11.6854C4.78964 11.6525 4.7548 11.6212 4.72077 11.5892C4.56403 11.4305 4.4061 11.2725 4.25055 11.1126C3.85197 10.7022 3.85079 10.1425 4.25451 9.73444C4.79241 9.1906 5.33387 8.64993 5.87849 8.11243C5.9628 8.02931 5.9723 7.98419 5.88206 7.89553C5.34772 7.3703 4.81972 6.83834 4.29013 6.30796C3.83733 5.85437 3.83852 5.30657 4.29171 4.8514C4.49357 4.64875 4.69543 4.4453 4.89888 4.24423C5.32793 3.82072 5.88562 3.81835 6.31111 4.24384C6.84465 4.77738 7.37701 5.31251 7.90145 5.85476C8.00198 5.95846 8.04909 5.94342 8.14091 5.85001C8.65506 5.32676 9.17634 4.80984 9.69563 4.29133C10.15 3.83814 10.6974 3.83853 11.1526 4.29054C11.2887 4.42591 11.4281 4.5585 11.5658 4.69228C11.6485 4.77619 11.7309 4.85971 11.8136 4.94362L11.8116 4.93966C11.8231 4.95114 11.8346 4.96301 11.846 4.97449L11.8425 4.97212C11.8452 4.99191 11.854 5.00576 11.8757 5.00695L11.873 5.00418C11.8737 5.02555 11.8809 5.04099 11.9058 5.03901L11.8999 5.03782V5.03822Z"
          fill="#FEFEFE"
        />
        <path
          d="M11.8132 4.94396C11.7305 4.86005 11.6482 4.77654 11.5654 4.69263C11.6818 4.74329 11.7669 4.82443 11.8132 4.94396Z"
          fill="#AD0F0F"
        />
        <path
          d="M11.845 4.97489C11.8335 4.96342 11.822 4.95194 11.8105 4.94006C11.822 4.95154 11.8335 4.96342 11.845 4.97489Z"
          fill="#AD0F0F"
        />
        <path
          d="M11.875 5.007C11.8533 5.00581 11.8446 4.99196 11.8418 4.97217C11.8529 4.98365 11.864 4.99512 11.875 5.007Z"
          fill="#AD0F0F"
        />
        <path
          d="M11.9049 5.03935C11.88 5.04093 11.8729 5.02549 11.8721 5.00452C11.8923 5.00768 11.9029 5.01916 11.9049 5.03935Z"
          fill="#AD0F0F"
        />
        <path
          d="M8.03223 10.055C8.03421 9.9952 8.08249 9.96631 8.11812 9.93069C8.72132 9.32788 9.32492 8.72586 9.92892 8.12384C9.9689 8.08426 10.0037 8.03518 10.0682 8.03162C10.3508 8.3067 10.6346 8.58099 10.9165 8.85726C11.1987 9.13433 11.4805 9.41179 11.7591 9.69241C12.1818 10.1175 12.1854 10.6744 11.767 11.107C11.5501 11.3314 11.3301 11.5531 11.1045 11.7688C10.6972 12.1579 10.1541 12.1654 9.75239 11.7755C9.18481 11.225 8.62831 10.6629 8.06745 10.1052C8.0532 10.091 8.0441 10.072 8.03223 10.055Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_957_6185">
          <rect
            width={16}
            height={15.9953}
            fill="white"
            transform="translate(0 0.00476074)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Reset: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M7.25 8.0835H2.66667V3.50016"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.69606 7.32318C5.72681 3.28908 10.6433 1.66504 14.6774 3.69578C18.7115 5.72652 20.3356 10.643 18.3048 14.6771C16.2741 18.7112 11.3576 20.3353 7.32346 18.3045C5.33268 17.3024 3.92883 15.5975 3.26148 13.6426"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Undo: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M7.99967 11.6666L3.83301 7.49992L7.99967 3.33325"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1663 16.6667V10.8333C17.1663 9.94928 16.8152 9.10143 16.19 8.47631C15.5649 7.85119 14.7171 7.5 13.833 7.5H3.83301"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Redo: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.5 11.6666L16.6667 7.49992L12.5 3.33325"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 16.6667V10.8333C3.33301 9.94928 3.6842 9.10143 4.30932 8.47631C4.93444 7.85119 5.78229 7.5 6.66634 7.5H16.6663"
        stroke={color ?? "#131313"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Transaction: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
    >
      <path
        d="M1 5.5H3.41886C4.06451 5.5 4.63772 5.08685 4.84189 4.47434L5.73656 1.79032C6.01829 0.945138 7.18124 0.862489 7.57967 1.65934L9.5 5.5L11.6056 9.71115C11.9741 10.4482 13.0259 10.4482 13.3944 9.71115L15.0854 6.32918C15.3395 5.821 15.8589 5.5 16.4271 5.5H19"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  LoadingGen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={37}
      viewBox="0 0 36 37"
      fill="none"
    >
      <path
        d="M3 20.7025C3.17142 20.7904 3.29887 20.8579 3.42721 20.9209C6.2678 22.3253 9.10749 23.7324 11.9526 25.1298C12.1985 25.2505 12.3528 25.4147 12.4731 25.6544C13.8965 28.4872 15.329 31.3156 16.7587 34.1449C16.8125 34.2514 16.8709 34.3571 16.9463 34.5C17.6463 33.1151 18.3248 31.7719 19.0042 30.4288C19.8245 28.8059 20.6404 27.1822 21.4723 25.5648C21.5504 25.4121 21.7012 25.2638 21.8556 25.1866C24.741 23.7484 27.6328 22.3209 30.5227 20.8907C30.6304 20.8375 30.7363 20.7789 30.8764 20.7052C30.7444 20.6342 30.6502 20.58 30.5533 20.5321C27.6732 19.1081 24.7913 17.6877 21.9175 16.2522C21.7263 16.1572 21.5397 15.9744 21.4427 15.7862C19.996 12.9524 18.5644 10.1107 17.1293 7.27082C17.08 7.17228 17.027 7.07552 16.9472 6.9246C16.8745 7.05599 16.817 7.15186 16.7668 7.25129C15.3361 10.0806 13.9037 12.9089 12.4794 15.7418C12.3537 15.9912 12.1931 16.1599 11.9355 16.286C9.08146 17.6877 6.2328 19.1019 3.38234 20.5134C3.27284 20.5676 3.16335 20.6226 3 20.7034L3 20.7025ZM16.9445 13.2587C17.0198 13.4025 17.0764 13.5082 17.1302 13.6156C17.8608 15.0591 18.5869 16.5052 19.33 17.9425C19.4135 18.1041 19.5732 18.2585 19.7366 18.342C20.8997 18.9341 22.0737 19.5058 23.2431 20.0855C23.6398 20.2817 24.0356 20.4806 24.4736 20.6999C24.3372 20.7718 24.2411 20.825 24.1433 20.873C22.684 21.5965 21.221 22.3138 19.7689 23.0506C19.5867 23.143 19.4081 23.3134 19.3148 23.4927C18.5743 24.9194 17.8554 26.3566 17.1302 27.7912C17.0764 27.8978 17.0207 28.0025 16.9445 28.1499C16.8718 28.0141 16.8179 27.9191 16.7685 27.8223C16.0326 26.3682 15.302 24.9123 14.5544 23.4643C14.471 23.3028 14.3121 23.1447 14.1487 23.0622C12.6858 22.3227 11.2139 21.6001 9.74471 20.8721C9.64689 20.8233 9.55085 20.7709 9.41713 20.7008C9.56611 20.6253 9.67291 20.5694 9.78151 20.5161C11.2211 19.8041 12.6652 19.0993 14.0976 18.3722C14.2888 18.2754 14.4736 18.0925 14.5715 17.9034C15.3182 16.4679 16.0425 15.02 16.7739 13.5765C16.8233 13.4798 16.8762 13.3857 16.9445 13.2578V13.2587Z"
        fill="url(#paint0_linear_1045_10855)"
      />
      <path
        d="M23 6.86607C23.7404 7.2336 24.4172 7.57006 25.0948 7.90563C25.7347 8.22256 26.3809 8.52795 27.0109 8.86263C27.1734 8.94874 27.3313 9.1041 27.4148 9.26656C28.0332 10.457 28.6318 11.6573 29.2376 12.8549C29.2915 12.9605 29.3507 13.0635 29.4306 13.21C29.5087 13.0732 29.5715 12.9747 29.6236 12.8717C30.2303 11.675 30.828 10.4739 31.4473 9.28431C31.5361 9.11387 31.7013 8.94697 31.8736 8.85908C33.0762 8.24564 34.2897 7.6544 35.4995 7.05517C35.6054 7.00279 35.7077 6.94242 35.8522 6.8643C35.7104 6.78618 35.6099 6.72492 35.5049 6.67254C34.2852 6.06887 33.0619 5.47141 31.8476 4.85709C31.6923 4.77896 31.5415 4.63071 31.4625 4.47802C30.7912 3.17835 30.1369 1.8698 29.4441 0.499993C29.3642 0.642034 29.3058 0.737021 29.2556 0.83645C28.6444 2.04291 28.0413 3.25381 27.4166 4.45316C27.3277 4.62361 27.1581 4.78518 26.9858 4.87307C25.793 5.48118 24.5895 6.06887 23.3904 6.66367C23.2818 6.71782 23.175 6.77552 23 6.86607Z"
        fill="#706DDA"
      />
      <path
        d="M1 31.557C2.06533 32.0843 3.07771 32.577 4.08112 33.0893C4.22651 33.1629 4.36652 33.3032 4.44191 33.447C4.91579 34.3499 5.36993 35.2625 5.83124 36.1715C5.8806 36.2683 5.93445 36.3624 6.00805 36.5C6.52591 35.4791 7.01146 34.4963 7.52483 33.5287C7.62445 33.3414 7.80664 33.1603 7.99601 33.0617C8.97429 32.5539 9.96782 32.0737 11.0107 31.5561C10.8698 31.4815 10.7774 31.43 10.6822 31.383C9.79281 30.9418 8.90608 30.4961 8.01127 30.0656C7.77882 29.9537 7.62176 29.8081 7.50688 29.5729C7.02492 28.5892 6.52232 27.6163 6.00536 26.5962C5.87073 26.8581 5.75316 27.0818 5.63918 27.3073C5.25864 28.0584 4.87181 28.8067 4.50384 29.564C4.39165 29.7957 4.24177 29.951 4.00573 30.0638C3.11002 30.4926 2.22419 30.9391 1.33477 31.3803C1.23604 31.4292 1.14001 31.4824 1.0009 31.5552L1 31.557Z"
        fill="#B9B8FD"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1045_10855"
          x1={30.8764}
          y1={6.9246}
          x2={-3.19245}
          y2={11.5511}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE55F4" />
          <stop offset={1} stopColor="#6DDBFE" />
        </linearGradient>
      </defs>
    </svg>
  ),
  Download: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.08203 16.5942H17.9154"
        stroke="#5553BA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.0003 3.39999L10.0003 12.1963M10.0003 12.1963L14.3984 8.9384M10.0003 12.1963L5.60214 8.9384"
        stroke="#5553BA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Tick: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.946 1.14424C10.0147 0.358169 8.6523 0.35817 7.72098 1.14424L6.87282 1.86013C6.47698 2.19423 5.98715 2.39714 5.471 2.44079L4.36505 2.53432C3.15067 2.63702 2.18731 3.60038 2.08461 4.81475L1.99108 5.9207C1.94743 6.43685 1.74452 6.92669 1.41042 7.32254L0.694533 8.17069C-0.0915378 9.102 -0.0915366 10.4644 0.694533 11.3957L1.41042 12.2439C1.74452 12.6397 1.94743 13.1296 1.99108 13.6457L2.08461 14.7517C2.18731 15.9661 3.15067 16.9295 4.36505 17.0321L5.471 17.1256C5.98715 17.1693 6.47698 17.3722 6.87283 17.7063L7.72098 18.4222C8.6523 19.2082 10.0147 19.2082 10.946 18.4222L11.7942 17.7063C12.19 17.3722 12.6799 17.1693 13.196 17.1256L14.302 17.0321C15.5164 16.9295 16.4797 15.9661 16.5824 14.7517L16.6759 13.6457C16.7196 13.1296 16.9225 12.6397 17.2566 12.2439L17.9725 11.3957C18.7585 10.4644 18.7585 9.102 17.9725 8.17069L17.2566 7.32253C16.9225 6.92669 16.7196 6.43685 16.6759 5.9207L16.5824 4.81475C16.4797 3.60038 15.5164 2.63702 14.302 2.53432L13.196 2.44079C12.6799 2.39714 12.19 2.19423 11.7942 1.86013L10.946 1.14424ZM13.8795 8.07875C14.3189 7.63942 14.3189 6.9271 13.8795 6.48777C13.4402 6.04842 12.7279 6.04842 12.2885 6.48777L8.08403 10.6923L6.37953 8.98777C5.9402 8.54842 5.22788 8.54842 4.78855 8.98777C4.3492 9.4271 4.3492 10.1394 4.78855 10.5788L7.28855 13.0787C7.72788 13.5181 8.4402 13.5181 8.87953 13.0787L13.8795 8.07875Z"
        fill="#5271FF"
      />
    </svg>
  ),
  Res: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <path
        d="M7.75 8.08301H3.16667V3.49967"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.19606 7.32293C6.22681 3.28884 11.1433 1.6648 15.1774 3.69554C19.2115 5.72628 20.8356 10.6428 18.8048 14.6769C16.7741 18.711 11.8576 20.335 7.82346 18.3043C5.83268 17.3022 4.42883 15.5972 3.76148 13.6424"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Prev: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M16.5 8L1.5 8M1.5 8L7.33333 1.75M1.5 8L7.33333 14.25"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Next: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M1.5 8L16.5 8M16.5 8L10.6667 1.75M16.5 8L10.6667 14.25"
        stroke="#7340D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Male: (color: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
    >
      <path
        d="M8.75077 10.3688V5.55215C9.33437 5.97296 9.88677 6.3714 10.4638 6.78644C11.1447 5.85747 11.8191 4.93644 12.5123 3.9916C10.6729 2.65986 8.84658 1.33751 6.99922 0C5.17219 1.32235 3.34516 2.6447 1.48763 3.98943C2.17286 4.92562 2.85011 5.85097 3.53461 6.78644C4.1095 6.3714 4.66262 5.97296 5.24696 5.55142V10.381C3.24281 10.9513 1.72572 12.1394 0.779902 13.9995C0.0387812 15.4568 -0.136884 16.9993 0.213716 18.5952C0.914914 21.7885 3.80464 24.0427 7.13279 23.9994C10.3775 23.9575 13.183 21.6239 13.8261 18.4169C14.56 14.7545 12.1936 11.1967 8.7515 10.3695L8.75077 10.3688ZM7.00648 20.5419C5.09162 20.5448 3.52808 18.9987 3.52227 17.0975C3.51719 15.1912 5.06839 13.6335 6.9789 13.6263C8.90974 13.6191 10.4762 15.1673 10.4762 17.083C10.4762 18.9857 8.91772 20.539 7.00576 20.5412L7.00648 20.5419Z"
        fill={color ?? "#3E227C"}
      />
    </svg>
  ),
  FeMale: (color: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="24"
      viewBox="0 0 15 24"
      fill="none"
    >
      <path
        d="M14.46 6.27218C14.3801 5.87113 14.3249 5.46291 14.2153 5.06903C13.3483 1.94514 10.4744 -0.115972 7.17139 0.00505882C4.01721 0.121077 1.30161 2.43642 0.672805 5.54742C-0.0220709 8.98427 2.07127 12.4061 5.49773 13.4345C5.58341 13.4603 5.66764 13.4882 5.75549 13.5154V17.1492H3.42036V20.5753H5.75549V24H9.22915V20.5939H11.5759V17.16H9.26037V13.5655C9.83762 13.3092 10.4337 13.1072 10.9652 12.7985C12.9555 11.6427 14.1056 9.92029 14.4106 7.65651C14.42 7.58705 14.4433 7.51973 14.46 7.45169C14.46 7.05852 14.46 6.66535 14.46 6.27218ZM4.02448 6.87733C4.01794 4.98595 5.56889 3.43905 7.47998 3.43117C9.39978 3.42329 10.9703 4.94871 10.9805 6.83221C10.9907 8.7372 9.43536 10.2891 7.5112 10.2927C5.59503 10.2963 4.03028 8.76298 4.02375 6.87733H4.02448Z"
        fill={color ?? "#3E227C"}
      />
    </svg>
  ),
  CheckBoxSuccess: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="#34C759"
        strokeWidth="2"
      />
      <path
        d="M7.5 11.5L10.206 14.5926C10.6185 15.064 11.3579 15.0445 11.7449 14.5519L16.5 8.5"
        stroke="#34C759"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Diamond: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.9961 3.49161L17.6821 6.38187C18.0788 7.06192 18.0396 7.91144 17.582 8.55209L11.6281 16.8876C10.8305 18.0043 9.17083 18.0043 8.37319 16.8876L2.41927 8.55209C1.96167 7.91144 1.92249 7.06192 2.31918 6.38187L4.00517 3.49161C4.36359 2.87717 5.02139 2.49935 5.73272 2.49935L14.2686 2.49935C14.9799 2.49935 15.6377 2.87717 15.9961 3.49161Z"
        stroke="#DB9D00"
        strokeWidth="2"
      />
      <path
        d="M2.5 7.5H17.5"
        stroke="#DB9D00"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Fit: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M1.45266 7.22504C1.45266 7.07573 1.44607 6.92621 1.45445 6.77729C1.46364 6.6138 1.55612 6.511 1.7219 6.50082C1.89986 6.48984 2.01591 6.58965 2.0245 6.76112C2.03948 7.06594 2.03888 7.37216 2.0259 7.67718C2.0185 7.84885 1.90346 7.95445 1.72809 7.94507C1.55552 7.93588 1.45905 7.82649 1.45306 7.65143C1.44826 7.5095 1.45206 7.36717 1.45206 7.22504C1.45226 7.22504 1.45246 7.22504 1.45266 7.22504Z"
        fill="white"
      />
      <path
        d="M0.718164 7.95216C0.860375 7.95216 1.00279 7.94937 1.145 7.95316C1.31976 7.95775 1.42503 8.05217 1.4468 8.22345C1.46677 8.38095 1.34453 8.52288 1.16217 8.53106C0.871161 8.54384 0.57875 8.54423 0.287736 8.53186C0.110172 8.52427 -0.00886943 8.42147 0.000518099 8.22983C0.00970589 8.0404 0.131145 7.95616 0.312703 7.95276C0.447724 7.95017 0.582944 7.95216 0.718164 7.95236V7.95216Z"
        fill="white"
      />
      <path
        d="M2.76784 7.95129C2.91005 7.95129 3.05246 7.9467 3.19427 7.95229C3.37024 7.95908 3.47829 8.06108 3.48548 8.23096C3.49267 8.40363 3.38601 8.52041 3.21424 8.52759C2.90925 8.54017 2.60286 8.54197 2.29826 8.5252C2.12809 8.51582 2.03002 8.39764 2.042 8.21918C2.05339 8.0517 2.15725 7.96247 2.32003 7.95349C2.46883 7.9451 2.61843 7.95169 2.76784 7.95149V7.95129Z"
        fill="white"
      />
      <path
        d="M1.45277 9.25812C1.45277 9.116 1.44858 8.97387 1.45377 8.83194C1.46036 8.65807 1.55044 8.54988 1.72861 8.54149C1.90797 8.53311 2.01882 8.63611 2.02621 8.80698C2.03939 9.1116 2.03879 9.41782 2.02481 9.72244C2.01682 9.89631 1.89458 9.99552 1.72241 9.98414C1.56323 9.97356 1.46216 9.87235 1.45477 9.70567C1.44818 9.55676 1.45337 9.40744 1.45337 9.25832C1.45317 9.25832 1.45277 9.25832 1.45257 9.25832L1.45277 9.25812Z"
        fill="white"
      />
      <g clipPath="url(#clip0_1575_32419)">
        <path
          d="M6.61592 6.53029C6.63255 6.5312 6.64963 6.53166 6.66625 6.53257V9.7655C6.75972 9.7655 6.82623 9.7655 6.89273 9.7655C7.99726 9.7655 9.10225 9.76277 10.2068 9.76641C10.8772 9.76868 11.3199 10.2212 11.3252 10.9026C11.3279 11.2378 11.3239 11.5734 11.3275 11.9091C11.3279 11.9687 11.3356 12.0406 11.3684 12.0851C11.7921 12.6582 12.0501 13.3086 12.2388 13.9909C12.2712 14.1082 12.3255 14.1369 12.4388 14.136C12.9713 14.13 13.5042 14.1332 14.0367 14.1332C14.4542 14.1332 14.5557 14.0313 14.5557 13.6129C14.5557 11.316 14.5557 9.01867 14.5557 6.72178V6.53211L14.602 6.51711C14.8366 6.76044 15.0698 7.00468 15.3061 7.2462C15.5506 7.4959 15.7182 7.49499 15.9645 7.24529C16.5796 6.62263 17.1939 5.99951 17.8082 5.37594C18.0643 5.11577 18.0634 4.94476 17.8037 4.68369C17.6923 4.5718 17.5813 4.45855 17.4653 4.35166C16.2633 3.24006 14.8514 2.61967 13.2274 2.50414C12.8841 2.47958 12.792 2.55827 12.7241 2.90166C12.4208 4.44035 10.6831 5.16535 9.40107 4.28526C8.90857 3.94732 8.6102 3.47429 8.49426 2.88393C8.4327 2.56964 8.328 2.48322 8.00895 2.50369C7.8301 2.51506 7.65081 2.5287 7.47376 2.55599C5.86549 2.80206 4.50437 3.5316 3.38051 4.72098C3.17381 4.93976 3.17021 5.12669 3.37962 5.33955C4.01322 5.98359 4.64772 6.62672 5.28312 7.26939C5.49656 7.48498 5.67855 7.48453 5.8938 7.26803C6.13645 7.02379 6.37552 6.77636 6.61592 6.53029ZM7.00777 18.4996C8.13477 18.4996 9.26222 18.4996 10.3892 18.4996C10.7932 18.4996 11.1967 18.501 11.6007 18.4991C11.9242 18.4978 12.0564 18.3527 12.0433 18.0216C12.0357 17.8342 12.033 17.6463 12.0231 17.4589C11.9647 16.356 11.8461 15.2617 11.5526 14.1942C11.3819 13.5729 11.1549 12.9761 10.751 12.464C10.6647 12.3544 10.573 12.303 10.4261 12.3034C8.16038 12.3089 5.89515 12.3089 3.62946 12.3034C3.47668 12.3034 3.38007 12.3539 3.28929 12.469C2.94733 12.9025 2.73164 13.3996 2.57166 13.9231C2.16679 15.2426 2.04501 16.6043 2.00097 17.9765C1.98794 18.3818 2.10343 18.4991 2.49887 18.4991C4.00153 18.4991 5.50465 18.4991 7.00732 18.4991L7.00777 18.4996ZM10.6112 11.5766C10.6112 11.3679 10.6112 11.1755 10.6112 10.9831C10.6112 10.6074 10.4975 10.49 10.1335 10.49C8.05928 10.49 5.98502 10.49 3.91076 10.49C3.86043 10.49 3.80921 10.4869 3.75978 10.4932C3.5998 10.5146 3.46679 10.6024 3.45286 10.7625C3.42994 11.0304 3.44657 11.3015 3.44657 11.5762H10.6108L10.6112 11.5766Z"
          fill="white"
        />
        <path
          d="M6.61554 6.53031C6.37513 6.77637 6.13562 7.0238 5.89341 7.26804C5.67862 7.48454 5.49618 7.485 5.28273 7.26941C4.64733 6.62719 4.01283 5.9836 3.37923 5.33957C3.16983 5.12671 3.17342 4.94022 3.38013 4.721C4.50398 3.53162 5.8651 2.80207 7.47382 2.55601C7.65087 2.52872 7.83016 2.51507 8.00901 2.5037C8.32806 2.48323 8.43276 2.57011 8.49432 2.88394C8.61026 3.47431 8.90863 3.94733 9.40114 4.28527C10.6832 5.16537 12.4209 4.44037 12.7242 2.90168C12.792 2.55783 12.8841 2.4796 13.2275 2.50416C14.8515 2.61968 16.2629 3.24007 17.4658 4.35077C17.5818 4.45811 17.6928 4.5709 17.8042 4.68279C18.0639 4.94386 18.0648 5.11488 17.8087 5.37504C17.1944 5.99861 16.5797 6.62173 15.965 7.24439C15.7183 7.49409 15.5511 7.495 15.3067 7.2453C15.0703 7.00379 14.8371 6.75954 14.6025 6.51621L14.5562 6.53122V6.72088C14.5562 9.01777 14.5562 11.3151 14.5562 13.612C14.5562 14.0309 14.4547 14.1323 14.0372 14.1323C13.5047 14.1323 12.9718 14.1291 12.4393 14.1351C12.3265 14.1364 12.2721 14.1073 12.2393 13.99C12.0506 13.3082 11.7926 12.6573 11.3689 12.0842C11.3361 12.0397 11.3285 11.9678 11.328 11.9082C11.3244 11.573 11.328 11.2373 11.3258 10.9017C11.3199 10.2208 10.8773 9.76779 10.2073 9.76551C9.10276 9.76188 7.99778 9.7646 6.89324 9.7646C6.82674 9.7646 6.76068 9.7646 6.66677 9.7646V6.53258C6.65014 6.53167 6.63306 6.53122 6.61644 6.53031H6.61554Z"
          fill="white"
        />
        <path
          d="M7.00732 18.4989C5.50465 18.4989 4.00153 18.4989 2.49887 18.4989C2.10343 18.4989 1.98794 18.3815 2.00097 17.9763C2.04501 16.6041 2.16679 15.2423 2.57076 13.9224C2.73119 13.3989 2.94643 12.9017 3.2884 12.4683C3.37917 12.3532 3.47623 12.3023 3.62856 12.3027C5.89425 12.3082 8.15948 12.3082 10.4252 12.3027C10.5721 12.3027 10.6638 12.3541 10.7501 12.4633C11.154 12.9754 11.381 13.5722 11.5517 14.1935C11.8452 15.261 11.9638 16.3553 12.0222 17.4582C12.0321 17.6456 12.0348 17.8335 12.0424 18.0209C12.0555 18.352 11.9238 18.4966 11.5998 18.4984C11.1963 18.5002 10.7923 18.4989 10.3883 18.4989C9.26132 18.4989 8.13387 18.4989 7.00687 18.4989H7.00732Z"
          fill="white"
        />
        <path
          d="M10.6109 11.5773H3.44626C3.44626 11.3026 3.42963 11.0315 3.45255 10.7636C3.46648 10.6035 3.59949 10.5158 3.75946 10.4944C3.80934 10.4876 3.86012 10.4912 3.91045 10.4912C5.98471 10.4912 8.05896 10.4912 10.1332 10.4912C10.4972 10.4912 10.6104 10.6086 10.6109 10.9842C10.6109 11.1766 10.6109 11.369 10.6109 11.5778V11.5773Z"
          fill="white"
        />
        <path
          d="M16.8005 15.4937C16.8032 16.0539 16.3727 16.4968 15.8225 16.5C15.2733 16.5031 14.8318 16.0629 14.8272 15.5077C14.8225 14.955 15.2617 14.5038 15.8084 14.5C16.3578 14.4963 16.7976 14.9369 16.8005 15.4937ZM15.8237 15.9306C16.0518 15.9253 16.2402 15.7282 16.2379 15.4969C16.2357 15.2667 16.0423 15.0708 15.8165 15.0698C15.5842 15.0689 15.3824 15.2797 15.3913 15.5148C15.4001 15.7453 15.5979 15.9359 15.8237 15.9306Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1575_32419">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Me: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M1.95559 16.7265C1.95559 16.5768 1.94899 16.427 1.95739 16.2778C1.9666 16.114 2.05926 16.011 2.22536 16.0008C2.40367 15.9898 2.51995 16.0898 2.52855 16.2616C2.54356 16.567 2.54296 16.8739 2.52995 17.1795C2.52255 17.3515 2.40728 17.4573 2.23157 17.4479C2.05866 17.4387 1.962 17.3291 1.95599 17.1537C1.95119 17.0115 1.95499 16.8689 1.95499 16.7265C1.95519 16.7265 1.95539 16.7265 1.95559 16.7265Z"
        fill="#ffffff"
      />
      <path
        d="M1.21957 17.4541C1.36206 17.4541 1.50475 17.4513 1.64724 17.4551C1.82235 17.4597 1.92782 17.5543 1.94963 17.7259C1.96965 17.8837 1.84717 18.0259 1.66445 18.0341C1.37287 18.047 1.07988 18.0474 0.788301 18.035C0.610388 18.0274 0.491113 17.9243 0.500519 17.7323C0.509725 17.5425 0.631402 17.4581 0.813317 17.4547C0.948602 17.4521 1.08409 17.4541 1.21957 17.4543V17.4541Z"
        fill="#ffffff"
      />
      <path
        d="M3.27317 17.4552C3.41566 17.4552 3.55835 17.4506 3.70044 17.4562C3.87675 17.463 3.98502 17.5652 3.99222 17.7354C3.99943 17.9084 3.89256 18.0254 3.72045 18.0326C3.41486 18.0452 3.10786 18.047 2.80267 18.0302C2.63216 18.0208 2.5339 17.9024 2.54591 17.7236C2.55732 17.5558 2.66138 17.4664 2.82448 17.4574C2.97358 17.449 3.12347 17.4556 3.27317 17.4554V17.4552Z"
        fill="#ffffff"
      />
      <path
        d="M1.95473 18.7634C1.95473 18.621 1.95053 18.4786 1.95573 18.3364C1.96233 18.1622 2.05259 18.0538 2.2311 18.0454C2.41082 18.037 2.52189 18.1402 2.52929 18.3114C2.5425 18.6166 2.5419 18.9234 2.52789 19.2287C2.51989 19.4029 2.39741 19.5023 2.2249 19.4909C2.0654 19.4803 1.96413 19.3789 1.95673 19.2119C1.95013 19.0627 1.95533 18.913 1.95533 18.7636C1.95513 18.7636 1.95473 18.7636 1.95453 18.7636L1.95473 18.7634Z"
        fill="#ffffff"
      />
      <path
        d="M18.3334 1.41604C18.3334 1.33036 18.3297 1.24457 18.3345 1.15912C18.3397 1.0653 18.3928 1.00631 18.4879 1.00047C18.5901 0.994171 18.6566 1.05144 18.6616 1.14984C18.6702 1.32475 18.6698 1.50046 18.6624 1.67549C18.6581 1.774 18.5921 1.83459 18.4915 1.82921C18.3925 1.82394 18.3371 1.76117 18.3337 1.66071C18.3309 1.57927 18.3331 1.4976 18.3331 1.41604C18.3332 1.41604 18.3333 1.41604 18.3334 1.41604Z"
        fill="#ffffff"
      />
      <path
        d="M17.9121 1.8326C17.9937 1.8326 18.0754 1.831 18.157 1.83317C18.2573 1.83581 18.3177 1.88999 18.3302 1.98827C18.3417 2.07865 18.2715 2.16009 18.1669 2.16478C17.9999 2.17211 17.8321 2.17234 17.6651 2.16524C17.5632 2.16089 17.4949 2.1019 17.5003 1.99193C17.5056 1.88323 17.5753 1.83489 17.6794 1.83294C17.7569 1.83145 17.8345 1.8326 17.9121 1.83271V1.8326Z"
        fill="#ffffff"
      />
      <path
        d="M19.088 1.83322C19.1696 1.83322 19.2513 1.83059 19.3327 1.83379C19.4336 1.83769 19.4956 1.89622 19.4998 1.9937C19.5039 2.09278 19.4427 2.15979 19.3441 2.16391C19.1691 2.17113 18.9933 2.17216 18.8185 2.16254C18.7209 2.15716 18.6646 2.08934 18.6715 1.98694C18.678 1.89084 18.7376 1.83963 18.831 1.83448C18.9164 1.82967 19.0022 1.83345 19.088 1.83334V1.83322Z"
        fill="#ffffff"
      />
      <path
        d="M18.3329 2.58337C18.3329 2.50181 18.3305 2.42025 18.3335 2.33881C18.3373 2.23904 18.389 2.17696 18.4912 2.17215C18.5941 2.16734 18.6578 2.22644 18.662 2.32449C18.6696 2.49929 18.6692 2.675 18.6612 2.8498C18.6566 2.94957 18.5865 3.0065 18.4877 2.99997C18.3963 2.9939 18.3383 2.93582 18.3341 2.84018C18.3303 2.75473 18.3333 2.66905 18.3333 2.58348C18.3332 2.58348 18.3329 2.58348 18.3328 2.58348L18.3329 2.58337Z"
        fill="#ffffff"
      />
      <path
        d="M13.7455 8.52713C14.3668 8.52713 14.995 8.46932 15.6082 8.53993C16.6857 8.66394 17.5308 9.55838 17.5771 10.6404C17.6207 11.6643 17.6285 12.6974 17.5433 13.7174C17.4038 15.3847 15.9266 16.8174 14.258 17.0088C12.1518 17.2504 10.3471 15.9465 9.94125 13.8844C9.90103 13.68 9.88042 13.4688 9.87861 13.2606C9.87141 12.4571 9.86941 11.6537 9.87641 10.8505C9.88822 9.52518 10.9085 8.50853 12.2353 8.49473C12.7386 8.48953 13.2421 8.49393 13.7455 8.49393C13.7455 8.50513 13.7455 8.51633 13.7455 8.52753V8.52713ZM13.7391 15.2049C14.3873 15.1893 14.9518 14.9685 15.4145 14.5057C15.6132 14.3068 15.6338 14.1082 15.4779 13.9572C15.3269 13.811 15.1401 13.8336 14.9464 14.0216C14.243 14.7047 13.2277 14.7037 12.5217 14.0192C12.329 13.8324 12.1404 13.8112 11.9899 13.9596C11.8403 14.1072 11.8569 14.3038 12.0432 14.4929C12.5083 14.9647 13.0778 15.1903 13.7389 15.2049H13.7391ZM12.0616 11.6787C12.3372 11.6757 12.5643 11.4417 12.5585 11.1669C12.5527 10.8917 12.3162 10.6668 12.0412 10.6754C11.7736 10.6838 11.5549 10.9093 11.5547 11.1767C11.5545 11.4519 11.7866 11.6817 12.0616 11.6787ZM15.4053 10.6754C15.1295 10.6802 14.9044 10.9151 14.9118 11.1905C14.919 11.4569 15.1449 11.6777 15.4117 11.6787C15.6873 11.6797 15.9176 11.4491 15.9156 11.1739C15.9138 10.8985 15.6805 10.6708 15.4053 10.6754Z"
        fill="#ffffff"
      />
      <path
        d="M16.9091 5.7933C16.9091 5.36027 16.9467 4.98265 16.9005 4.61563C16.8269 4.033 16.3382 3.63577 15.7494 3.63097C15.0365 3.62517 14.3237 3.63178 13.611 3.62818C13.2858 3.62658 13.0613 3.41156 13.0655 3.11915C13.0689 2.87493 13.2532 2.63512 13.4992 2.63392C14.3717 2.62972 15.2499 2.59052 16.1154 2.67412C17.1232 2.77133 17.8999 3.68738 17.9248 4.70023C17.9448 5.51668 17.9338 6.33413 17.9296 7.15097C17.928 7.48379 17.7264 7.7314 17.4184 7.80861C17.122 7.88281 16.8341 7.7638 16.6738 7.47559C16.3822 6.95136 16.0978 6.42293 15.8194 5.8917C15.6793 5.62448 15.7666 5.34007 16.0103 5.20406C16.2609 5.06425 16.5467 5.15346 16.7072 5.42447C16.7692 5.52908 16.8243 5.63769 16.9091 5.7935V5.7933Z"
        fill="#ffffff"
      />
      <path
        d="M4.17577 13.9384C4.17577 14.4104 4.14415 14.885 4.18377 15.3538C4.2332 15.9375 4.73712 16.3647 5.32669 16.3739C5.8088 16.3813 6.2911 16.3745 6.77321 16.3763C7.12243 16.3775 7.34977 16.5727 7.35497 16.8707C7.36018 17.1761 7.12743 17.3849 6.7684 17.3807C6.16823 17.3735 5.56244 17.4061 4.96947 17.3343C3.98305 17.2149 3.19915 16.3333 3.17013 15.3402C3.14252 14.3914 3.15833 13.4413 3.16353 12.4917C3.16513 12.1823 3.36446 11.9466 3.65824 11.8658C3.94762 11.7862 4.24401 11.8906 4.39771 12.1631C4.7029 12.7035 4.99689 13.2505 5.28327 13.8011C5.41455 14.0538 5.31409 14.3392 5.07674 14.4684C4.83859 14.598 4.55901 14.5204 4.40431 14.2756C4.33387 14.164 4.27443 14.0454 4.20999 13.93C4.19858 13.9328 4.18717 13.9356 4.17577 13.9382V13.9384Z"
        fill="#ffffff"
      />
      <path
        d="M10.208 8.82595C10.4806 8.55393 10.803 8.34372 11.1572 8.20252C11.1576 8.19792 11.1582 8.19332 11.1586 8.18851C11.2441 7.16866 11.2363 6.1354 11.1925 5.11155C11.1462 4.02949 10.3011 3.13504 9.22361 3.01103C8.61043 2.94043 7.98223 2.99823 7.36084 2.99823C7.36084 2.98703 7.36084 2.97583 7.36084 2.96463C6.85732 2.96463 6.354 2.96023 5.85068 2.96543C4.52385 2.97923 3.5036 3.99609 3.49179 5.32116C3.48459 6.1246 3.48659 6.92805 3.494 7.73129C3.4958 7.9395 3.51641 8.15091 3.55664 8.35513C3.96249 10.4172 5.76723 11.7209 7.87336 11.4795C8.4055 11.4185 8.91822 11.2311 9.37411 10.9501C9.37431 10.9149 9.37471 10.8795 9.37491 10.8445C9.38171 10.0718 9.6777 9.35478 10.2078 8.82535L10.208 8.82595ZM9.02108 5.14655C9.29646 5.14175 9.52961 5.36956 9.53141 5.64498C9.53321 5.92039 9.30306 6.151 9.02749 6.1498C8.76072 6.1488 8.53478 5.92799 8.52757 5.66158C8.52017 5.38616 8.74511 5.15115 9.02108 5.14655ZM5.17045 5.64778C5.17065 5.38036 5.38939 5.15495 5.65696 5.14655C5.93194 5.13795 6.16868 5.36276 6.17429 5.63798C6.18009 5.91279 5.95275 6.1468 5.67737 6.1498C5.4024 6.1528 5.17025 5.92279 5.17045 5.64778ZM9.03009 8.97676C8.5674 9.43958 8.00284 9.6604 7.35463 9.676C6.69362 9.6614 6.12406 9.43558 5.65896 8.96396C5.47264 8.77495 5.45603 8.57834 5.60573 8.43073C5.75602 8.28252 5.94474 8.30372 6.13746 8.49033C6.84331 9.17477 7.85875 9.17577 8.5622 8.49273C8.75592 8.30472 8.94284 8.28192 9.09373 8.42833C9.24943 8.57914 9.22882 8.77795 9.03029 8.97676H9.03009Z"
        fill="#ffffff"
      />
    </svg>
  ),
  Hair: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M19.166 12.073C19.1674 12.3531 18.9493 12.5746 18.6704 12.5762C18.3921 12.5777 18.1684 12.3576 18.166 12.08C18.1637 11.8037 18.3862 11.5781 18.6633 11.5762C18.9417 11.5743 19.1645 11.7946 19.166 12.073ZM18.671 12.2915C18.7866 12.2888 18.8821 12.1903 18.8809 12.0746C18.8798 11.9595 18.7818 11.8616 18.6674 11.8611C18.5496 11.8606 18.4474 11.966 18.4519 12.0836C18.4563 12.1988 18.5566 12.2941 18.671 12.2915Z"
        fill="#ffffff"
      />
      <path
        d="M2.61867 6.30117C2.61867 6.15187 2.61208 6.00236 2.62047 5.85345C2.62966 5.68997 2.72213 5.58717 2.8879 5.57699C3.06585 5.56601 3.18189 5.66582 3.19048 5.83728C3.20546 6.14209 3.20486 6.44828 3.19188 6.75328C3.18449 6.92495 3.06945 7.03054 2.89409 7.02116C2.72153 7.01198 2.62506 6.90259 2.61907 6.72753C2.61428 6.58561 2.61807 6.44329 2.61807 6.30117C2.61827 6.30117 2.61847 6.30117 2.61867 6.30117Z"
        fill="#ffffff"
      />
      <path
        d="M1.88414 7.02833C2.02634 7.02833 2.16875 7.02554 2.31095 7.02933C2.48571 7.03392 2.59096 7.12834 2.61273 7.2996C2.63271 7.4571 2.51047 7.59902 2.32813 7.6072C2.03713 7.61997 1.74473 7.62037 1.45374 7.608C1.27618 7.60041 1.15715 7.49762 1.16653 7.30599C1.17572 7.11657 1.29715 7.03233 1.4787 7.02893C1.61371 7.02634 1.74893 7.02834 1.88414 7.02853V7.02833Z"
        fill="#ffffff"
      />
      <path
        d="M3.93284 7.02746C4.07504 7.02746 4.21744 7.02287 4.35925 7.02846C4.5352 7.03525 4.64325 7.13725 4.65044 7.30711C4.65763 7.47977 4.55098 7.59655 4.37922 7.60373C4.07424 7.61631 3.76786 7.6181 3.46329 7.60134C3.29312 7.59195 3.19506 7.47379 3.20704 7.29534C3.21842 7.12787 3.32228 7.03864 3.48505 7.02966C3.63385 7.02128 3.78344 7.02786 3.93284 7.02766V7.02746Z"
        fill="#ffffff"
      />
      <path
        d="M2.61781 8.33426C2.61781 8.19214 2.61362 8.05002 2.61881 7.90809C2.6254 7.73424 2.71548 7.62605 2.89363 7.61766C3.07298 7.60928 3.18383 7.71228 3.19122 7.88314C3.2044 8.18775 3.2038 8.49395 3.18982 8.79855C3.18183 8.97241 3.0596 9.07161 2.88744 9.06023C2.72826 9.04966 2.6272 8.94845 2.61981 8.78178C2.61322 8.63287 2.61841 8.48357 2.61841 8.33446C2.61821 8.33446 2.61781 8.33446 2.61761 8.33446L2.61781 8.33426Z"
        fill="#ffffff"
      />
      <path
        d="M16.8936 15.6096C16.7514 15.6094 16.609 15.6146 16.4672 15.608C16.2868 15.5996 16.1564 15.4744 16.1666 15.3158C16.1778 15.1415 16.2816 15.0371 16.4538 15.0313C16.7448 15.0217 17.0368 15.0199 17.3276 15.0313C17.5155 15.0385 17.6268 15.1664 17.6132 15.3343C17.598 15.5237 17.4804 15.607 17.2986 15.6094C17.1636 15.6112 17.0286 15.6098 16.8936 15.6094V15.6096Z"
        fill="#ffffff"
      />
      <path
        d="M18.9309 15.608C18.7957 15.608 18.6607 15.6088 18.5255 15.608C18.3409 15.607 18.2283 15.5146 18.2069 15.3324C18.1883 15.1739 18.3128 15.0369 18.4961 15.0299C18.7871 15.019 19.0793 15.0184 19.3705 15.0299C19.5566 15.0373 19.6687 15.1687 19.6541 15.3353C19.6387 15.5126 19.5299 15.6002 19.3573 15.6066C19.2153 15.6118 19.0729 15.6076 18.9307 15.6078L18.9309 15.608Z"
        fill="#ffffff"
      />
      <path
        d="M18.2012 16.3556C18.2014 16.4977 18.2077 16.6402 18.1998 16.7817C18.1906 16.9448 18.1001 17.0488 17.9339 17.06C17.756 17.072 17.6381 16.9732 17.6301 16.8017C17.6158 16.4901 17.6172 16.1767 17.6323 15.8649C17.6403 15.7015 17.7608 15.6084 17.9239 15.6156C18.0853 15.6228 18.1884 15.7216 18.1988 15.8865C18.2087 16.0422 18.201 16.1991 18.2012 16.3554V16.3556Z"
        fill="#ffffff"
      />
      <path
        d="M18.2011 14.3245C18.2011 14.4666 18.2091 14.6092 18.1989 14.7505C18.1871 14.9138 18.092 15.013 17.9249 15.0198C17.7579 15.0265 17.6403 14.9361 17.6319 14.774C17.6157 14.4627 17.6177 14.1495 17.6289 13.8377C17.6349 13.6734 17.7497 13.5744 17.9113 13.5762C18.0815 13.578 18.1903 13.6792 18.1995 13.856C18.2075 14.0119 18.2011 14.1684 18.2011 14.3247V14.3245Z"
        fill="#ffffff"
      />
      <path
        d="M13.6815 17.1945C13.3437 17.0937 13.107 16.8945 13.0425 16.5316C13.0314 16.4689 13.0308 16.4038 13.0308 16.3398C13.0302 11.8476 13.0302 7.35538 13.0306 2.86319C13.0306 2.32864 13.3545 2.00468 13.8888 2.00448C14.9467 2.00388 16.0046 2.01146 17.0626 2.00009C17.3937 1.99649 17.6264 2.10468 17.7476 2.41966V2.657C17.62 2.9608 17.3895 3.0634 17.0658 3.05482C16.4538 3.03865 15.8409 3.0624 15.2289 3.04583C14.8169 3.03465 14.5081 3.31371 14.6275 3.84008C14.6787 3.84008 14.7324 3.84008 14.7859 3.84008C15.6551 3.84008 16.5243 3.84307 17.3935 3.83728C17.5531 3.83629 17.6719 3.879 17.7478 4.02172V4.17003C17.6797 4.32173 17.5571 4.36345 17.3989 4.36265C16.5299 4.35906 15.6609 4.36086 14.7917 4.36086C14.7336 4.36086 14.6755 4.36086 14.612 4.36086V4.88423C14.6743 4.88423 14.7276 4.88423 14.7809 4.88423C15.6451 4.88423 16.5091 4.88743 17.3731 4.88144C17.5355 4.88024 17.6613 4.91976 17.7478 5.06009V5.23814C17.6585 5.37547 17.5321 5.41459 17.3705 5.41359C16.5105 5.4076 15.6505 5.41079 14.7905 5.41079C14.7328 5.41079 14.6751 5.41079 14.614 5.41079V5.93038H14.8019C15.6569 5.93038 16.5119 5.93297 17.3672 5.92818C17.5261 5.92738 17.6558 5.96351 17.7478 6.09865V6.2767C17.6677 6.41403 17.5511 6.45994 17.3909 6.45874C16.5165 6.45235 15.6419 6.45575 14.7675 6.45575C14.7154 6.45575 14.6635 6.45575 14.6144 6.45575V6.98331C14.6791 6.98331 14.7328 6.98331 14.7863 6.98331C15.6559 6.98331 16.5255 6.98611 17.3949 6.98072C17.5543 6.97972 17.6741 7.02124 17.7478 7.16676V7.31506C17.6773 7.46417 17.5559 7.50589 17.3971 7.50509C16.5279 7.5007 15.6585 7.50309 14.7893 7.50309C14.7316 7.50309 14.6737 7.50309 14.612 7.50309V8.02826H14.7813C15.6505 8.02826 16.5199 8.03166 17.3891 8.02527C17.5493 8.02407 17.6653 8.07118 17.7478 8.20531V8.38337C17.6572 8.5193 17.5297 8.55763 17.3689 8.55663C16.5091 8.55104 15.6491 8.55403 14.7891 8.55403H14.6146V9.07322H14.8035C15.6585 9.07322 16.5135 9.07581 17.3684 9.07082C17.5283 9.06982 17.6572 9.10695 17.7476 9.24368V9.42173C17.6659 9.55647 17.5499 9.60397 17.3899 9.60277C16.5163 9.59639 15.6425 9.59978 14.7687 9.59978H14.6152C14.5385 10.116 14.7743 10.4094 15.2904 10.3892C15.872 10.3667 16.4554 10.395 17.0374 10.3797C17.3691 10.3709 17.6122 10.4733 17.7474 10.7865V11.0238C17.631 11.3362 17.4005 11.4452 17.0758 11.439C16.4332 11.427 15.7901 11.4342 15.1474 11.4362C14.8744 11.437 14.6761 11.5899 14.6186 11.843C14.6034 11.9095 14.6032 11.9801 14.6032 12.0488C14.6024 13.4921 14.6032 14.9355 14.602 16.3789C14.6016 16.7629 14.4021 17.0368 14.0408 17.1629C14.0188 17.1705 13.999 17.1841 13.9782 17.1949H13.6815V17.1945Z"
        fill="#ffffff"
      />
      <path
        d="M10.0015 17.1952C9.90147 17.1714 9.80021 17.1508 9.70114 17.1233C8.88607 16.8961 8.32325 16.1648 8.31486 15.3152C8.30987 14.7963 8.30548 14.2771 8.31606 13.7583C8.32625 13.2483 8.1463 12.8299 7.78579 12.471C6.84849 11.5379 7.05201 11.8323 6.57387 10.6189C5.75081 8.52995 4.92615 6.44185 4.11567 4.34816C3.84744 3.65532 3.88499 2.98024 4.37871 2.38081C4.46559 2.27522 4.57304 2.1832 4.68269 2.10016C4.90139 1.93429 5.06596 1.98419 5.16682 2.23909C5.49377 3.06487 5.81912 3.89125 6.14506 4.71743C7.18283 7.34747 8.22039 9.97751 9.25816 12.6074C9.39457 12.9529 9.55914 13.0523 9.93163 13.0156C10.9968 12.9106 11.9193 13.6978 11.9784 14.7763C11.9984 15.14 12.0227 15.5095 11.9101 15.8656C11.6824 16.5844 11.1947 17.0167 10.4559 17.167C10.4225 17.1738 10.3902 17.1856 10.3574 17.1952H10.0013H10.0015ZM10.926 15.1081H10.9278C10.9278 14.9897 10.9368 14.8705 10.9262 14.7531C10.8897 14.3531 10.5464 14.0489 10.1435 14.0519C9.74708 14.0549 9.40396 14.3575 9.3754 14.7514C9.35822 14.9867 9.35802 15.2258 9.37699 15.461C9.40835 15.851 9.76266 16.1536 10.1563 16.1488C10.5478 16.144 10.8855 15.8464 10.9243 15.463C10.936 15.3458 10.926 15.2264 10.926 15.1081Z"
        fill="#ffffff"
      />
      <path
        d="M4.15514 17.1954C3.83678 17.1203 3.52901 17.0223 3.26777 16.8127C2.80821 16.4441 2.56215 15.9662 2.55635 15.3782C2.55336 15.0686 2.54737 14.7504 2.61148 14.4508C2.8118 13.5138 3.69218 12.9074 4.63967 13.0206C4.94944 13.0575 5.14158 12.9479 5.25702 12.6589C5.50368 12.0405 5.74714 11.4207 5.9922 10.8015C6.00299 10.7744 6.01597 10.748 6.03614 10.7031C6.29718 11.264 6.40563 11.888 6.94249 12.3581C6.86479 12.4086 6.7905 12.4425 6.73417 12.4956C6.38406 12.825 6.21709 13.2318 6.22148 13.713C6.22588 14.2021 6.22268 14.6913 6.22228 15.1803C6.22148 16.2451 5.64668 16.9539 4.60752 17.1734C4.59433 17.1762 4.58295 17.188 4.57077 17.1954H4.15534H4.15514ZM5.17653 15.1009C5.17373 15.1009 5.17094 15.1007 5.16834 15.1005C5.16834 15.0017 5.17154 14.9029 5.16774 14.8043C5.15196 14.4007 4.8326 14.0759 4.43136 14.053C4.03491 14.0302 3.66842 14.3067 3.62108 14.7011C3.59012 14.9584 3.59032 15.2247 3.61828 15.4826C3.65943 15.8644 3.98777 16.1371 4.37084 16.1484C4.73694 16.1594 5.07946 15.8951 5.15156 15.5285C5.17893 15.3897 5.16934 15.2436 5.17653 15.1009Z"
        fill="#ffffff"
      />
      <path
        d="M8.49998 9.25644C8.34579 8.86441 8.20359 8.50233 8.06099 8.14044C7.9074 7.7504 7.74942 7.36196 7.60302 6.96913C7.57686 6.89907 7.57406 6.80186 7.60082 6.733C8.18621 5.23553 8.777 3.74006 9.36758 2.2446C9.47144 1.98151 9.63022 1.9376 9.8623 2.10427C10.528 2.58193 10.7619 3.48416 10.4317 4.32991C9.91902 5.64413 9.40173 6.95656 8.88645 8.26958C8.76222 8.58616 8.63819 8.90294 8.49958 9.25644H8.49998Z"
        fill="#ffffff"
      />
    </svg>
  ),
  Check: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path
        d="M1 6.21538L5.95226 10.9989C6.33979 11.3732 6.95421 11.3732 7.34174 10.9989L17 1.66992"
        stroke={color ?? "#050358"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DiamondBtn: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
    >
      <path
        d="M9.82882 1.49226L10.3481 2.38252C10.7448 3.06257 10.7057 3.91209 10.248 4.55274L7.62747 8.22155C6.82983 9.33824 5.17018 9.33824 4.37253 8.22155L1.75195 4.55274C1.29435 3.91209 1.25517 3.06257 1.65186 2.38252L2.17118 1.49226C2.5296 0.877823 3.18741 0.5 3.89874 0.5L8.10126 0.5C8.81259 0.5 9.4704 0.877822 9.82882 1.49226Z"
        fill="#FFCB00"
        stroke="#534200"
      />
      <path d="M1.5 3.5H10.5" stroke="#534200" strokeLinecap="round" />
    </svg>
  ),
  Premium: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#FFCB00" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white" />
      <path
        d="M14.3702 5.74161L15.1811 7.13187C15.5778 7.81192 15.5387 8.66144 15.0811 9.30209L11.6271 14.1376C10.8295 15.2543 9.16985 15.2543 8.37221 14.1376L4.9183 9.30209C4.46069 8.66144 4.42151 7.81192 4.81821 7.13187L5.62919 5.74161C5.98761 5.12717 6.64542 4.74935 7.35675 4.74935L12.6426 4.74935C13.3539 4.74935 14.0117 5.12717 14.3702 5.74161Z"
        stroke="white"
      />
      <path d="M4.75 8.25H15.25" stroke="white" strokeLinecap="round" />
    </svg>
  ),
  DividerImg: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="217"
      viewBox="0 0 20 217"
      fill="none"
    >
      <path
        d="M1.5 108.971C0.833333 108.587 0.833333 107.624 1.5 107.239L4.5 105.507C5.16667 105.122 6 105.604 6 106.373L6 109.838C6 110.607 5.16667 111.088 4.5 110.704L1.5 108.971Z"
        fill="white"
        fillOpacity="0.8"
      />
      <path d="M10 0L10 216.21" stroke="white" strokeWidth="2" />
      <path
        d="M18.5 107.239C19.1667 107.624 19.1667 108.587 18.5 108.971L15.5 110.704C14.8333 111.088 14 110.607 14 109.838L14 106.373C14 105.604 14.8333 105.122 15.5 105.507L18.5 107.239Z"
        fill="white"
        fillOpacity="0.8"
      />
    </svg>
  ),
  DeleteIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <rect
        x="0.650391"
        y="0.25"
        width="13.5"
        height="13.5"
        rx="6.75"
        fill="white"
      />
      <rect
        x="0.650391"
        y="0.25"
        width="13.5"
        height="13.5"
        rx="6.75"
        stroke="#B2B2B2"
        strokeWidth="0.5"
      />
      <path
        d="M10.3167 9.91634L4.4834 4.08301"
        stroke="#B2B2B2"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.3167 4.08301L4.4834 9.91634"
        stroke="#B2B2B2"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Uploaded: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.08325 6.36107V14.9166C1.08325 16.0212 1.97868 16.9166 3.08325 16.9166H14.9166C16.0212 16.9166 16.9166 16.0212 16.9166 14.9166V6.36107M1.08325 6.36107H8.99992H16.9166M1.08325 6.36107V3.08331C1.08325 1.97874 1.97868 1.08331 3.08325 1.08331H14.9166C16.0212 1.08331 16.9166 1.97874 16.9166 3.08331V6.36107"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
      />
      <path
        d="M8.99986 13.8378V9.87952M8.99986 9.87952L6.80078 11.6388M8.99986 9.87952L11.1989 11.6388"
        stroke={color ?? "#3E227C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TickI: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M2.33301 6.73452L4.93235 9.24528C5.31988 9.6196 5.9343 9.6196 6.32184 9.24529L11.6663 4.08301"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  FullScreen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V6M19 6V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H14M14 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V14M1 14V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  NextRight: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
    >
      <path
        d="M1.33341 0.666992L5.95964 5.29322C6.35017 5.68374 6.35016 6.31691 5.95964 6.70743L1.33341 11.3337"
        stroke="#A3A3A3"
        strokeLinecap="round"
      />
    </svg>
  ),
  FullStep: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V6M19 6V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H14M14 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V14M1 14V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H6"
        stroke="rgba(178, 178, 178, 1)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  EditName: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M15.6665 17.3335L2.33317 17.3335"
        stroke="#A3A3A3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6021 7.70355L7.51201 13.7936C7.2557 14.05 6.93454 14.2318 6.58287 14.3197L2.7433 15.2796C2.37711 15.3712 2.04542 15.0395 2.13696 14.6733L3.09686 10.8337C3.18477 10.482 3.36661 10.1609 3.62293 9.90456L9.71303 3.81447M13.6021 7.70355L15.4288 5.87686C16.2099 5.09581 16.2099 3.82948 15.4288 3.04843L14.3681 1.98777C13.5871 1.20672 12.3208 1.20672 11.5397 1.98777L9.71303 3.81447M13.6021 7.70355L9.71303 3.81447"
        stroke="#A3A3A3"
      />
    </svg>
  ),
  NextSlide: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
    >
      <path
        d="M1 1L8.29289 8.29289C8.68342 8.68342 8.68342 9.31658 8.29289 9.70711L1 17"
        stroke="#121219"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  PrevSlide: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
    >
      <path
        d="M9 1L1.70711 8.29289C1.31658 8.68342 1.31658 9.31658 1.70711 9.70711L9 17"
        stroke="#121219"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Link: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="13"
      viewBox="0 0 24 13"
      fill="none"
    >
      <path
        d="M10.4634 1.88965H6.11C3.56397 1.88965 1.5 3.95362 1.5 6.49965V6.49965C1.5 9.04568 3.56397 11.1096 6.11 11.1096H10.4634M13.5366 1.88965H17.89C20.436 1.88965 22.5 3.95362 22.5 6.49965V6.49965C22.5 9.04568 20.436 11.1096 17.89 11.1096H13.5366"
        stroke="#785BBA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.0977 6.5L7.90253 6.5"
        stroke="#785BBA"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  Copy: (color: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
    >
      <path
        d="M18.7506 16.9167H7.58398C6.47941 16.9167 5.58398 16.0212 5.58398 14.9167V3.75C5.58398 2.64543 6.47941 1.75 7.58398 1.75H18.7506C19.8552 1.75 20.7507 2.64543 20.7507 3.75V14.9167C20.7507 16.0212 19.8552 16.9167 18.7506 16.9167Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.58333 6.08301L3.25 6.08301C2.14543 6.08301 1.25 6.97844 1.25 8.08301L1.25 19.2497C1.25 20.3542 2.14543 21.2497 3.25 21.2497L14.4167 21.2497C15.5212 21.2497 16.4167 20.3542 16.4167 19.2497L16.4167 16.9163"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  CloseDialog: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
    >
      <path
        d="M8.5 8L1.5 1"
        stroke="#B2B2B2"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.5 1L1.5 8"
        stroke="#B2B2B2"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  NextDialog: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M1.5 7.5L16.5 7.5M16.5 7.5L10.6667 1.25M16.5 7.5L10.6667 13.75"
        stroke="#FF52F0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  IconDropdown: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M11.334 1.33366L6.70776 5.95989C6.31723 6.35041 5.68407 6.35041 5.29354 5.95988L0.667318 1.33366"
        stroke="#A3A3A3"
        strokeLinecap="round"
      />
    </svg>
  ),
  IconDropUp: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M0.666016 5.66634L5.29224 1.04011C5.68277 0.64959 6.31593 0.649591 6.70646 1.04012L11.3327 5.66634"
        stroke="#A3A3A3"
        strokeLinecap="round"
      />
    </svg>
  ),
  PlusCate: (color: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 3.33301V12.6663"
        stroke={color ?? "#A3A3A3"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.666 8L3.33268 8"
        stroke={color ?? "#A3A3A3"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Find: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.33846 17.6769C13.9437 17.6769 17.6769 13.9437 17.6769 9.33846C17.6769 4.73326 13.9437 1 9.33846 1C4.73326 1 1 4.73326 1 9.33846C1 13.9437 4.73326 17.6769 9.33846 17.6769Z"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33846 17.6769C13.9437 17.6769 17.6769 13.9437 17.6769 9.33846C17.6769 4.73326 13.9437 1 9.33846 1C4.73326 1 1 4.73326 1 9.33846C1 13.9437 4.73326 17.6769 9.33846 17.6769Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19L16 16"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19L16 16"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Eraser: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M18 18.958H8C7.65833 18.958 7.375 18.6747 7.375 18.333C7.375 17.9913 7.65833 17.708 8 17.708H18C18.3417 17.708 18.625 17.9913 18.625 18.333C18.625 18.6747 18.3417 18.958 18 18.958Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M7.61612 18.925C6.78279 18.925 5.99115 18.6 5.40782 18.0083L2.48281 15.0833C1.26615 13.8667 1.26615 11.8833 2.48281 10.6667L11.1745 1.975C12.3495 0.8 14.4161 0.8 15.5911 1.975L18.5161 4.9C19.7328 6.11666 19.7328 8.1 18.5161 9.31666L9.82448 18.0083C9.24114 18.6083 8.45779 18.925 7.61612 18.925ZM3.36614 14.2083L6.29115 17.1333C6.99949 17.8417 8.24115 17.8417 8.94115 17.1333L17.6328 8.44166C18.3661 7.70833 18.3661 6.52499 17.6328 5.79166L14.7078 2.86667C14.0078 2.16667 12.7661 2.15833 12.0578 2.86667L3.36614 11.5583C2.63281 12.2833 2.63281 13.475 3.36614 14.2083Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M12.8898 14.6916C12.7315 14.6916 12.5732 14.6333 12.4482 14.5083L5.98984 8.04994C5.74818 7.80827 5.74818 7.40827 5.98984 7.1666C6.23151 6.92493 6.63151 6.92493 6.87318 7.1666L13.3315 13.6249C13.5732 13.8666 13.5732 14.2666 13.3315 14.5083C13.2065 14.6333 13.0482 14.6916 12.8898 14.6916Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M3.43153 15.3415C3.2732 15.3415 3.11484 15.2832 2.98984 15.1582C2.74818 14.9165 2.74818 14.5165 2.98984 14.2749L7.70654 9.5582C7.94821 9.31654 8.3482 9.31654 8.58987 9.5582C8.83154 9.79987 8.83154 10.1999 8.58987 10.4415L3.87318 15.1582C3.74818 15.2832 3.58987 15.3415 3.43153 15.3415Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M5.7831 17.6999C5.62476 17.6999 5.46641 17.6416 5.34141 17.5166C5.09974 17.2749 5.09974 16.8749 5.34141 16.6333L10.0581 11.9166C10.2997 11.6749 10.6998 11.6749 10.9414 11.9166C11.1831 12.1583 11.1831 12.5583 10.9414 12.7999L6.22474 17.5166C6.10807 17.6333 5.94976 17.6999 5.7831 17.6999Z"
        fill={color ?? "#3B3899"}
      />
    </svg>
  ),
  Brush: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.69354 15.3079C8.56854 15.3079 8.45188 15.2746 8.34354 15.1996C8.16854 15.0829 8.06854 14.8913 8.06854 14.6829C8.06854 14.5579 8.06021 14.4246 8.04354 14.2913C7.96854 13.6996 7.70188 13.1829 7.25188 12.7329C6.80188 12.2829 6.24354 11.9996 5.64354 11.9246C5.54354 11.9163 5.40188 11.9079 5.26854 11.9163C5.05188 11.9329 4.85188 11.8413 4.72688 11.6663C4.60188 11.4996 4.56854 11.2746 4.63521 11.0746C4.76021 10.7329 4.94354 10.4246 5.16021 10.1746L6.44354 8.55794C8.65188 5.79961 13.1269 2.48294 16.4019 1.16628C17.0935 0.899609 17.8352 1.05794 18.3435 1.55794C18.8685 2.08294 19.0269 2.83294 18.7519 3.51628C17.4352 6.79961 14.1269 11.2663 11.3685 13.4746L9.72688 14.7913C9.41854 15.0163 9.16854 15.1579 8.91854 15.2579C8.85188 15.2913 8.76854 15.3079 8.69354 15.3079ZM6.28521 10.7829C6.98521 10.9663 7.61021 11.3329 8.13521 11.8579C8.66021 12.3746 9.01021 12.9746 9.18521 13.6413L10.5935 12.5079C13.2102 10.4163 16.3519 6.17461 17.5935 3.05794C17.7185 2.74961 17.5435 2.53294 17.4602 2.45794C17.4019 2.39961 17.1852 2.21628 16.8519 2.34128C13.7519 3.59128 9.51021 6.73294 7.41021 9.34961L6.28521 10.7829Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M3.40143 18.9585C2.77643 18.9585 2.17643 18.7085 1.72643 18.2585C1.20977 17.7419 0.959768 17.0252 1.0431 16.2919L1.2681 14.2419C1.48477 12.2085 3.15144 10.7002 5.2181 10.6585C5.37644 10.6502 5.58477 10.6585 5.77643 10.6752C6.68477 10.7919 7.4931 11.2002 8.1431 11.8502C8.78477 12.4919 9.1681 13.2585 9.28477 14.1169C9.30977 14.3002 9.32644 14.5002 9.32644 14.6752C9.32644 15.7752 8.90144 16.8002 8.13477 17.5752C7.4931 18.2085 6.6681 18.6002 5.73477 18.7169L3.67643 18.9419C3.58477 18.9502 3.4931 18.9585 3.40143 18.9585ZM5.37643 11.9169C5.3431 11.9169 5.30144 11.9169 5.2681 11.9169C4.00977 11.9419 2.67643 12.8002 2.50977 14.3835L2.28477 16.4335C2.2431 16.7835 2.3681 17.1252 2.60977 17.3752C2.85143 17.6169 3.1931 17.7419 3.53477 17.7002L5.58477 17.4752C6.22644 17.3919 6.80144 17.1252 7.23477 16.6919C7.7681 16.1585 8.0681 15.4419 8.0681 14.6752C8.0681 14.5502 8.05977 14.4169 8.0431 14.2835C7.9681 13.6919 7.70144 13.1752 7.25144 12.7252C6.80143 12.2752 6.2431 11.9919 5.6431 11.9169C5.57644 11.9169 5.47644 11.9169 5.37643 11.9169Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M11.8674 12.6829C11.5258 12.6829 11.2424 12.3995 11.2424 12.0579C11.2424 10.2245 9.75078 8.74121 7.92578 8.74121C7.58411 8.74121 7.30078 8.45788 7.30078 8.11621C7.30078 7.77454 7.57578 7.49121 7.91745 7.49121C10.4341 7.49121 12.4841 9.54121 12.4841 12.0579C12.4924 12.4079 12.2091 12.6829 11.8674 12.6829Z"
        fill={color ?? "#3B3899"}
      />
    </svg>
  ),
  Click: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.643 18.975C13.6347 18.975 13.6346 18.975 13.6263 18.975C12.7846 18.9667 12.0846 18.4501 11.8346 17.6417L10.293 12.6834C10.0846 12.0001 10.2596 11.2667 10.768 10.775C11.268 10.2834 11.993 10.1 12.6597 10.3084L17.6263 11.8501C18.4263 12.1001 18.9513 12.8 18.9596 13.6417C18.968 14.475 18.4597 15.1834 17.6597 15.4501L16.3013 15.9084C16.1096 15.9751 15.9597 16.1167 15.9013 16.3084L15.4346 17.675C15.1763 18.4667 14.4763 18.975 13.643 18.975ZM12.093 11.475C11.868 11.475 11.718 11.6 11.6513 11.6584C11.4763 11.8334 11.418 12.0751 11.493 12.3167L13.0346 17.2751C13.168 17.7001 13.5346 17.7167 13.6513 17.725C13.768 17.725 14.1263 17.6917 14.2596 17.2834L14.7263 15.9167C14.9096 15.3584 15.3596 14.9167 15.918 14.7251L17.2763 14.2667C17.693 14.1334 17.718 13.7667 17.718 13.6584C17.718 13.5501 17.6847 13.1834 17.268 13.0501L12.3013 11.5084C12.218 11.4834 12.1513 11.475 12.093 11.475Z"
        fill={color ?? "#3B3899"}
      />
      <path
        d="M10.0013 18.9587C5.05964 18.9587 1.04297 14.942 1.04297 10.0003C1.04297 5.05866 5.05964 1.04199 10.0013 1.04199C14.943 1.04199 18.9596 5.05866 18.9596 10.0003C18.9596 10.342 18.6763 10.6253 18.3346 10.6253C17.993 10.6253 17.7096 10.342 17.7096 10.0003C17.7096 5.75033 14.2513 2.29199 10.0013 2.29199C5.7513 2.29199 2.29297 5.75033 2.29297 10.0003C2.29297 14.2503 5.7513 17.7087 10.0013 17.7087C10.343 17.7087 10.6263 17.992 10.6263 18.3337C10.6263 18.6753 10.343 18.9587 10.0013 18.9587Z"
        fill={color ?? "#3B3899"}
      />
    </svg>
  ),
  PenArt: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.33521 14.5802C2.84187 14.5802 2.35521 14.3936 1.98187 14.0202C1.62187 13.6602 1.42188 13.1802 1.42188 12.6669C1.42188 12.1536 1.62187 11.6736 1.98187 11.3136L10.6485 2.64691C11.3952 1.90025 12.6085 1.90025 13.3552 2.64691C13.7152 3.00691 13.9152 3.48691 13.9152 4.00025C13.9152 4.51358 13.7152 4.99358 13.3552 5.35358L4.68854 14.0202C4.31521 14.3936 3.82854 14.5802 3.33521 14.5802ZM12.0019 3.08691C11.7685 3.08691 11.5352 3.17358 11.3552 3.35358L2.68854 12.0202C2.51521 12.1936 2.42188 12.4202 2.42188 12.6669C2.42188 12.9136 2.51521 13.1402 2.68854 13.3136C3.04188 13.6669 3.62854 13.6669 3.98187 13.3136L12.6485 4.64691C12.8219 4.47358 12.9152 4.24691 12.9152 4.00025C12.9152 3.75358 12.8219 3.52691 12.6485 3.35358C12.4685 3.17358 12.2352 3.08691 12.0019 3.08691Z"
        fill={color ?? "#666666"}
      />
      <path
        d="M3.33521 14.5802C2.84187 14.5802 2.35521 14.3936 1.98187 14.0202C1.62187 13.6602 1.42188 13.1802 1.42188 12.6669C1.42188 12.1536 1.62187 11.6736 1.98187 11.3136L10.6485 2.64691C11.3952 1.90025 12.6085 1.90025 13.3552 2.64691C13.7152 3.00691 13.9152 3.48691 13.9152 4.00025C13.9152 4.51358 13.7152 4.99358 13.3552 5.35358L4.68854 14.0202C4.31521 14.3936 3.82854 14.5802 3.33521 14.5802ZM12.0019 3.08691C11.7685 3.08691 11.5352 3.17358 11.3552 3.35358L2.68854 12.0202C2.51521 12.1936 2.42188 12.4202 2.42188 12.6669C2.42188 12.9136 2.51521 13.1402 2.68854 13.3136C3.04188 13.6669 3.62854 13.6669 3.98187 13.3136L12.6485 4.64691C12.8219 4.47358 12.9152 4.24691 12.9152 4.00025C12.9152 3.75358 12.8219 3.52691 12.6485 3.35358C12.4685 3.17358 12.2352 3.08691 12.0019 3.08691Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M12.0061 6.49345C11.8795 6.49345 11.7528 6.44678 11.6528 6.34678L9.65281 4.34678C9.45948 4.15345 9.45948 3.83345 9.65281 3.64012C9.84615 3.44678 10.1661 3.44678 10.3595 3.64012L12.3595 5.64012C12.5528 5.83345 12.5528 6.15345 12.3595 6.34678C12.2595 6.44678 12.1328 6.49345 12.0061 6.49345Z"
        fill={color ?? "#666666"}
      />
      <path
        d="M12.0061 6.49345C11.8795 6.49345 11.7528 6.44678 11.6528 6.34678L9.65281 4.34678C9.45948 4.15345 9.45948 3.83345 9.65281 3.64012C9.84615 3.44678 10.1661 3.44678 10.3595 3.64012L12.3595 5.64012C12.5528 5.83345 12.5528 6.15345 12.3595 6.34678C12.2595 6.44678 12.1328 6.49345 12.0061 6.49345Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M6.66475 3.66703C6.63141 3.66703 6.60475 3.66036 6.57141 3.65369L5.66475 3.38703L4.75808 3.65369C4.63808 3.68703 4.51141 3.65369 4.43141 3.56703C4.34475 3.48036 4.31141 3.36036 4.34475 3.24036L4.61141 2.33369L4.34475 1.42703C4.31141 1.30703 4.34475 1.18036 4.43141 1.10036C4.51808 1.01369 4.64475 0.98036 4.75808 1.01369L5.66475 1.28036L6.57141 1.01369C6.69141 0.98036 6.81141 1.01369 6.89808 1.10036C6.98475 1.18703 7.01808 1.31369 6.98475 1.42703L6.71808 2.33369L6.98475 3.24036C7.01808 3.36036 6.98475 3.48703 6.89808 3.56703C6.83808 3.63369 6.75141 3.66703 6.66475 3.66703ZM5.66475 2.70703C5.69808 2.70703 5.72475 2.71369 5.75808 2.72036L6.17141 2.84036L6.05141 2.42703C6.03141 2.36703 6.03141 2.30036 6.05141 2.24036L6.17141 1.82703L5.75808 1.94703C5.69808 1.96703 5.63141 1.96703 5.57141 1.94703L5.15808 1.82703L5.27808 2.24036C5.29808 2.30036 5.29808 2.36703 5.27808 2.42703L5.15808 2.84036L5.57141 2.72036C5.60475 2.71369 5.63141 2.70703 5.66475 2.70703Z"
        fill={color ?? "#666666"}
      />
      <path
        d="M6.66475 3.66703C6.63141 3.66703 6.60475 3.66036 6.57141 3.65369L5.66475 3.38703L4.75808 3.65369C4.63808 3.68703 4.51141 3.65369 4.43141 3.56703C4.34475 3.48036 4.31141 3.36036 4.34475 3.24036L4.61141 2.33369L4.34475 1.42703C4.31141 1.30703 4.34475 1.18036 4.43141 1.10036C4.51808 1.01369 4.64475 0.98036 4.75808 1.01369L5.66475 1.28036L6.57141 1.01369C6.69141 0.98036 6.81141 1.01369 6.89808 1.10036C6.98475 1.18703 7.01808 1.31369 6.98475 1.42703L6.71808 2.33369L6.98475 3.24036C7.01808 3.36036 6.98475 3.48703 6.89808 3.56703C6.83808 3.63369 6.75141 3.66703 6.66475 3.66703ZM5.66475 2.70703C5.69808 2.70703 5.72475 2.71369 5.75808 2.72036L6.17141 2.84036L6.05141 2.42703C6.03141 2.36703 6.03141 2.30036 6.05141 2.24036L6.17141 1.82703L5.75808 1.94703C5.69808 1.96703 5.63141 1.96703 5.57141 1.94703L5.15808 1.82703L5.27808 2.24036C5.29808 2.30036 5.29808 2.36703 5.27808 2.42703L5.15808 2.84036L5.57141 2.72036C5.60475 2.71369 5.63141 2.70703 5.66475 2.70703Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M4.00069 7.66703C3.96735 7.66703 3.94069 7.66036 3.90735 7.65369L3.00069 7.38703L2.09402 7.65369C1.97402 7.68703 1.85402 7.65369 1.76735 7.56703C1.68069 7.48036 1.64735 7.35369 1.68069 7.24036L1.94735 6.33369L1.68069 5.42703C1.64735 5.30703 1.68069 5.18036 1.76735 5.10036C1.85402 5.02036 1.98069 4.98036 2.09402 5.01369L3.00069 5.28036L3.90735 5.01369C4.02069 4.98036 4.14735 5.01369 4.23402 5.10036C4.32069 5.18703 4.35402 5.31369 4.32069 5.42703L4.05402 6.33369L4.32069 7.24036C4.35402 7.36036 4.32069 7.48703 4.23402 7.56703C4.17402 7.63369 4.08735 7.66703 4.00069 7.66703ZM3.00069 6.70703C3.03402 6.70703 3.06069 6.71369 3.09402 6.72036L3.50735 6.84036L3.38735 6.42703C3.36735 6.36703 3.36735 6.30036 3.38735 6.24036L3.50735 5.82703L3.09402 5.94703C3.03402 5.96703 2.96735 5.96703 2.90735 5.94703L2.49402 5.82703L2.61402 6.24036C2.63402 6.30036 2.63402 6.36703 2.61402 6.42703L2.49402 6.84036L2.90735 6.72036C2.94069 6.71369 2.96735 6.70703 3.00069 6.70703Z"
        fill={color ?? "#666666"}
      />
      <path
        d="M4.00069 7.66703C3.96735 7.66703 3.94069 7.66036 3.90735 7.65369L3.00069 7.38703L2.09402 7.65369C1.97402 7.68703 1.85402 7.65369 1.76735 7.56703C1.68069 7.48036 1.64735 7.35369 1.68069 7.24036L1.94735 6.33369L1.68069 5.42703C1.64735 5.30703 1.68069 5.18036 1.76735 5.10036C1.85402 5.02036 1.98069 4.98036 2.09402 5.01369L3.00069 5.28036L3.90735 5.01369C4.02069 4.98036 4.14735 5.01369 4.23402 5.10036C4.32069 5.18703 4.35402 5.31369 4.32069 5.42703L4.05402 6.33369L4.32069 7.24036C4.35402 7.36036 4.32069 7.48703 4.23402 7.56703C4.17402 7.63369 4.08735 7.66703 4.00069 7.66703ZM3.00069 6.70703C3.03402 6.70703 3.06069 6.71369 3.09402 6.72036L3.50735 6.84036L3.38735 6.42703C3.36735 6.36703 3.36735 6.30036 3.38735 6.24036L3.50735 5.82703L3.09402 5.94703C3.03402 5.96703 2.96735 5.96703 2.90735 5.94703L2.49402 5.82703L2.61402 6.24036C2.63402 6.30036 2.63402 6.36703 2.61402 6.42703L2.49402 6.84036L2.90735 6.72036C2.94069 6.71369 2.96735 6.70703 3.00069 6.70703Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M14.0007 11C13.9674 11 13.9407 10.9934 13.9074 10.9867L13.0007 10.72L12.094 10.9867C11.974 11.02 11.854 10.9867 11.7674 10.9C11.6807 10.8134 11.6474 10.6867 11.6807 10.5734L11.9474 9.6667L11.6807 8.76003C11.6474 8.64003 11.6807 8.51337 11.7674 8.43337C11.854 8.35337 11.9807 8.31337 12.094 8.3467L13.0007 8.61337L13.9074 8.3467C14.0207 8.31337 14.1474 8.3467 14.234 8.43337C14.3207 8.52003 14.354 8.6467 14.3207 8.76003L14.054 9.6667L14.3207 10.5734C14.354 10.6934 14.3207 10.82 14.234 10.9C14.174 10.9667 14.0874 11 14.0007 11ZM13.0007 10.04C13.034 10.04 13.0607 10.0467 13.094 10.0534L13.5074 10.1734L13.3874 9.76003C13.3674 9.70003 13.3674 9.63337 13.3874 9.57337L13.5074 9.16003L13.094 9.28003C13.034 9.30003 12.9674 9.30003 12.9074 9.28003L12.494 9.16003L12.614 9.57337C12.634 9.63337 12.634 9.70003 12.614 9.76003L12.494 10.1734L12.9074 10.0534C12.9407 10.0467 12.9674 10.04 13.0007 10.04Z"
        fill={color ?? "#666666"}
      />
      <path
        d="M14.0007 11C13.9674 11 13.9407 10.9934 13.9074 10.9867L13.0007 10.72L12.094 10.9867C11.974 11.02 11.854 10.9867 11.7674 10.9C11.6807 10.8134 11.6474 10.6867 11.6807 10.5734L11.9474 9.6667L11.6807 8.76003C11.6474 8.64003 11.6807 8.51337 11.7674 8.43337C11.854 8.35337 11.9807 8.31337 12.094 8.3467L13.0007 8.61337L13.9074 8.3467C14.0207 8.31337 14.1474 8.3467 14.234 8.43337C14.3207 8.52003 14.354 8.6467 14.3207 8.76003L14.054 9.6667L14.3207 10.5734C14.354 10.6934 14.3207 10.82 14.234 10.9C14.174 10.9667 14.0874 11 14.0007 11ZM13.0007 10.04C13.034 10.04 13.0607 10.0467 13.094 10.0534L13.5074 10.1734L13.3874 9.76003C13.3674 9.70003 13.3674 9.63337 13.3874 9.57337L13.5074 9.16003L13.094 9.28003C13.034 9.30003 12.9674 9.30003 12.9074 9.28003L12.494 9.16003L12.614 9.57337C12.634 9.63337 12.634 9.70003 12.614 9.76003L12.494 10.1734L12.9074 10.0534C12.9407 10.0467 12.9674 10.04 13.0007 10.04Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  ),
  Animate: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6359 14.2341H13.578C13.7174 14.2341 13.8306 14.1209 13.8306 13.9815C13.8306 13.842 13.7174 13.7289 13.578 13.7289H10.6359C10.4965 13.7289 10.3833 13.842 10.3833 13.9815C10.3833 14.1209 10.4965 14.2341 10.6359 14.2341ZM2.08974 14.2341H5.03886C5.17831 14.2341 5.29149 14.1209 5.29149 13.9815C5.29149 13.842 5.17831 13.7289 5.03886 13.7289H2.08974C1.95029 13.7289 1.83711 13.842 1.83711 13.9815C1.83711 14.1209 1.95029 14.2341 2.08974 14.2341ZM14.5623 13.2499V8.19207C14.5623 8.05261 14.4491 7.93943 14.3096 7.93943C14.1702 7.93943 14.057 8.05261 14.057 8.19207V13.2499C14.057 13.3893 14.1702 13.5025 14.3096 13.5025C14.4491 13.5025 14.5623 13.3893 14.5623 13.2499ZM1.10547 8.19207V13.2083C1.10547 13.3477 1.21865 13.4609 1.35811 13.4609C1.49756 13.4609 1.61074 13.3477 1.61074 13.2083V8.19207C1.61074 8.05261 1.49756 7.93943 1.35811 7.93943C1.21865 7.93943 1.10547 8.05261 1.10547 8.19207ZM1.10547 1.76162V6.72879C1.10547 6.86825 1.21865 6.98143 1.35811 6.98143C1.49756 6.98143 1.61074 6.86825 1.61074 6.72879V1.76162C1.61074 1.62216 1.49756 1.50898 1.35811 1.50898C1.21865 1.50898 1.10547 1.62216 1.10547 1.76162ZM14.5623 6.72879V1.79547C14.5623 1.65601 14.4491 1.54283 14.3096 1.54283C14.1702 1.54283 14.057 1.65601 14.057 1.79547V6.72879C14.057 6.86825 14.1702 6.98143 14.3096 6.98143C14.4491 6.98143 14.5623 6.86825 14.5623 6.72879ZM7.04126 0.777344H2.16115C2.0217 0.777344 1.90852 0.890525 1.90852 1.02998C1.90852 1.16944 2.0217 1.28262 2.16115 1.28262H7.04126C7.18071 1.28262 7.29389 1.16944 7.29389 1.02998C7.29389 0.890525 7.18071 0.777344 7.04126 0.777344ZM13.578 0.777344H8.58722C8.44777 0.777344 8.33459 0.890525 8.33459 1.02998C8.33459 1.16944 8.44777 1.28262 8.58722 1.28262H13.578C13.7174 1.28262 13.8306 1.16944 13.8306 1.02998C13.8306 0.890525 13.7174 0.777344 13.578 0.777344Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34355 0.634408C2.34355 0.477941 2.2814 0.328044 2.17091 0.217557C2.06026 0.106902 1.91036 0.0449219 1.75406 0.0449219C1.51709 0.0449219 1.20146 0.0449219 0.964486 0.0449219C0.808188 0.0449219 0.658122 0.106902 0.547635 0.217557C0.437149 0.328044 0.375 0.477941 0.375 0.634408V1.42398C0.375 1.58028 0.437149 1.73018 0.547635 1.84083C0.658122 1.95132 0.808188 2.01347 0.964486 2.01347H1.75406C1.91036 2.01347 2.06026 1.95132 2.17091 1.84083C2.2814 1.73018 2.34355 1.58028 2.34355 1.42398V0.634408ZM1.83827 0.634408V1.42398C1.83827 1.44621 1.82935 1.46777 1.81368 1.48344C1.79785 1.49927 1.77646 1.50819 1.75406 1.50819H0.964486C0.942086 1.50819 0.920696 1.49927 0.904864 1.48344C0.8892 1.46777 0.880274 1.44621 0.880274 1.42398V0.634408C0.880274 0.612007 0.8892 0.590617 0.904864 0.574786C0.920696 0.558954 0.942086 0.550196 0.964486 0.550196H1.75406C1.77646 0.550196 1.79785 0.558954 1.81368 0.574786C1.82935 0.590617 1.83827 0.612007 1.83827 0.634408Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34355 13.5856C2.34355 13.4293 2.2814 13.2792 2.17091 13.1687C2.06026 13.0582 1.91036 12.9961 1.75406 12.9961C1.51709 12.9961 1.20146 12.9961 0.964486 12.9961C0.808188 12.9961 0.658122 13.0582 0.547635 13.1687C0.437149 13.2792 0.375 13.4293 0.375 13.5856V14.3752C0.375 14.5315 0.437149 14.6814 0.547635 14.792C0.658122 14.9025 0.808188 14.9646 0.964486 14.9646H1.75406C1.91036 14.9646 2.06026 14.9025 2.17091 14.792C2.2814 14.6814 2.34355 14.5315 2.34355 14.3752V13.5856ZM1.83827 13.5856V14.3752C1.83827 14.3976 1.82935 14.4189 1.81368 14.4346C1.79785 14.4504 1.77646 14.4594 1.75406 14.4594H0.964486C0.942086 14.4594 0.920696 14.4504 0.904864 14.4346C0.8892 14.4189 0.880274 14.3976 0.880274 14.3752V13.5856C0.880274 13.5632 0.8892 13.5418 0.904864 13.526C0.920696 13.5103 0.942086 13.5014 0.964486 13.5014H1.75406C1.77646 13.5014 1.79785 13.5103 1.81368 13.526C1.82935 13.5418 1.83827 13.5632 1.83827 13.5856Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34355 7.0641C2.34355 6.9078 2.2814 6.7579 2.17091 6.64724C2.06026 6.53676 1.91036 6.47461 1.75406 6.47461C1.51709 6.47461 1.20146 6.47461 0.964486 6.47461C0.808188 6.47461 0.658122 6.53676 0.547635 6.64724C0.437149 6.7579 0.375 6.9078 0.375 7.0641V7.85367C0.375 8.00997 0.437149 8.16003 0.547635 8.27052C0.658122 8.38101 0.808188 8.44316 0.964486 8.44316H1.75406C1.91036 8.44316 2.06026 8.38101 2.17091 8.27052C2.2814 8.16003 2.34355 8.00997 2.34355 7.85367V7.0641ZM1.83827 7.0641V7.85367C1.83827 7.87607 1.82935 7.89746 1.81368 7.91329C1.79785 7.92896 1.77646 7.93788 1.75406 7.93788H0.964486C0.942086 7.93788 0.920696 7.92896 0.904864 7.91329C0.8892 7.89746 0.880274 7.87607 0.880274 7.85367V7.0641C0.880274 7.04169 0.8892 7.0203 0.904864 7.00464C0.920696 6.98881 0.942086 6.97988 0.964486 6.97988H1.75406C1.77646 6.97988 1.79785 6.98881 1.81368 7.00464C1.82935 7.0203 1.83827 7.04169 1.83827 7.0641Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2967 0.634408C15.2967 0.477941 15.2345 0.328044 15.124 0.217557C15.0135 0.106902 14.8635 0.0449219 14.7072 0.0449219C14.4702 0.0449219 14.1546 0.0449219 13.9176 0.0449219C13.7613 0.0449219 13.6114 0.106902 13.5008 0.217557C13.3903 0.328044 13.3281 0.477941 13.3281 0.634408V1.42398C13.3281 1.58028 13.3903 1.73018 13.5008 1.84083C13.6114 1.95132 13.7613 2.01347 13.9176 2.01347H14.7072C14.8635 2.01347 15.0135 1.95132 15.124 1.84083C15.2345 1.73018 15.2967 1.58028 15.2967 1.42398V0.634408ZM14.7914 0.634408V1.42398C14.7914 1.44621 14.7825 1.46777 14.7668 1.48344C14.751 1.49927 14.7296 1.50819 14.7072 1.50819H13.9176C13.8952 1.50819 13.8738 1.49927 13.858 1.48344C13.8423 1.46777 13.8334 1.44621 13.8334 1.42398V0.634408C13.8334 0.612007 13.8423 0.590617 13.858 0.574786C13.8738 0.558954 13.8952 0.550196 13.9176 0.550196H14.7072C14.7296 0.550196 14.751 0.558954 14.7668 0.574786C14.7825 0.590617 14.7914 0.612007 14.7914 0.634408Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2967 13.5856C15.2967 13.4293 15.2345 13.2792 15.124 13.1687C15.0135 13.0582 14.8635 12.9961 14.7072 12.9961C14.4702 12.9961 14.1546 12.9961 13.9176 12.9961C13.7613 12.9961 13.6114 13.0582 13.5008 13.1687C13.3903 13.2792 13.3281 13.4293 13.3281 13.5856V14.3752C13.3281 14.5315 13.3903 14.6814 13.5008 14.792C13.6114 14.9025 13.7613 14.9646 13.9176 14.9646H14.7072C14.8635 14.9646 15.0135 14.9025 15.124 14.792C15.2345 14.6814 15.2967 14.5315 15.2967 14.3752V13.5856ZM14.7914 13.5856V14.3752C14.7914 14.3976 14.7825 14.4189 14.7668 14.4346C14.751 14.4504 14.7296 14.4594 14.7072 14.4594H13.9176C13.8952 14.4594 13.8738 14.4504 13.858 14.4346C13.8423 14.4189 13.8334 14.3976 13.8334 14.3752V13.5856C13.8334 13.5632 13.8423 13.5418 13.858 13.526C13.8738 13.5103 13.8952 13.5014 13.9176 13.5014H14.7072C14.7296 13.5014 14.751 13.5103 14.7668 13.526C14.7825 13.5418 14.7914 13.5632 14.7914 13.5856Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2967 7.0641C15.2967 6.9078 15.2345 6.7579 15.124 6.64724C15.0135 6.53676 14.8635 6.47461 14.7072 6.47461C14.4702 6.47461 14.1546 6.47461 13.9176 6.47461C13.7613 6.47461 13.6114 6.53676 13.5008 6.64724C13.3903 6.7579 13.3281 6.9078 13.3281 7.0641V7.85367C13.3281 8.00997 13.3903 8.16003 13.5008 8.27052C13.6114 8.38101 13.7613 8.44316 13.9176 8.44316H14.7072C14.8635 8.44316 15.0135 8.38101 15.124 8.27052C15.2345 8.16003 15.2967 8.00997 15.2967 7.85367V7.0641ZM14.7914 7.0641V7.85367C14.7914 7.87607 14.7825 7.89746 14.7668 7.91329C14.751 7.92896 14.7296 7.93788 14.7072 7.93788H13.9176C13.8952 7.93788 13.8738 7.92896 13.858 7.91329C13.8423 7.89746 13.8334 7.87607 13.8334 7.85367V7.0641C13.8334 7.04169 13.8423 7.0203 13.858 7.00464C13.8738 6.98881 13.8952 6.97988 13.9176 6.97988H14.7072C14.7296 6.97988 14.751 6.98881 14.7668 7.00464C14.7825 7.0203 14.7914 7.04169 14.7914 7.0641Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44105 0C7.28475 0 7.13468 0.0621487 7.0242 0.172635C6.91371 0.28329 6.85156 0.433188 6.85156 0.589486V1.37906C6.85156 1.53536 6.91371 1.68542 7.0242 1.79591C7.13468 1.9064 7.28475 1.96855 7.44105 1.96855H8.23062C8.38692 1.96855 8.53699 1.9064 8.64747 1.79591C8.75796 1.68542 8.82011 1.53536 8.82011 1.37906C8.82011 1.14209 8.82011 0.826459 8.82011 0.589486C8.82011 0.433188 8.75796 0.28329 8.64747 0.172635C8.53699 0.0621487 8.38692 0 8.23062 0H7.44105ZM7.44105 0.505274H8.23062C8.25302 0.505274 8.27441 0.5142 8.29025 0.529864C8.30591 0.545696 8.31484 0.567086 8.31484 0.589486V1.37906C8.31484 1.40146 8.30591 1.42285 8.29025 1.43868C8.27441 1.45435 8.25302 1.46327 8.23062 1.46327H7.44105C7.41865 1.46327 7.39726 1.45435 7.38143 1.43868C7.36576 1.42285 7.35684 1.40146 7.35684 1.37906V0.589486C7.35684 0.567086 7.36576 0.545696 7.38143 0.529864C7.39726 0.5142 7.41865 0.505274 7.44105 0.505274Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35647 16.0005H6.62848C7.0007 16.0005 7.31784 15.7302 7.37679 15.3627L7.8344 12.5096L8.29201 15.3627C8.35096 15.7302 8.6681 16.0005 9.04032 16.0005H9.31232C9.52252 16.0005 9.72311 15.9133 9.86644 15.7597C10.0098 15.606 10.083 15.3999 10.0685 15.1904L9.60117 8.42543L11.5485 8.28244C11.9445 8.25347 12.2508 7.9237 12.2508 7.52672V7.12419C12.2508 6.89159 12.0624 6.70312 11.8298 6.70312H3.83903C3.60644 6.70312 3.41797 6.89159 3.41797 7.12419V7.52672C3.41797 7.9237 3.72433 8.25347 4.1203 8.28244L6.06762 8.42543L5.60025 15.1904C5.58576 15.3999 5.65903 15.606 5.80236 15.7597C5.94568 15.9133 6.14628 16.0005 6.35647 16.0005Z"
        fill="white"
      />
      <ellipse
        cx="7.83314"
        cy="4.29408"
        rx="1.85267"
        ry="1.85267"
        fill="white"
      />
    </svg>
  ),
  Moon: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        d="M15.2456 14.4609C13.7883 14.4518 12.3597 14.0467 11.1061 13.2873C9.85247 12.5279 8.81906 11.4414 8.11178 10.1393C7.4045 8.83709 7.04881 7.36612 7.08116 5.87715C7.10547 4.75857 7.34813 3.66007 7.7909 2.64484C7.96266 2.25103 7.63626 1.80132 7.22765 1.93405C5.65008 2.44651 4.25173 3.43741 3.22618 4.78755C1.97436 6.43558 1.36765 8.50083 1.52422 10.581C1.68078 12.6612 2.58943 14.6073 4.07314 16.0403C5.55685 17.4732 7.50937 18.2904 9.55036 18.3327C10.9467 18.3363 12.3203 17.9711 13.5379 17.2725C14.4454 16.7519 15.2433 16.0592 15.8907 15.235C16.1537 14.9001 15.853 14.4398 15.4275 14.4559C15.3669 14.4582 15.3062 14.4599 15.2456 14.4609Z"
        stroke={color ?? "#121219"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Earth: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.47375 1.42542C5.06801 5.21627 4.99783 12.4997 7.26324 16.4941"
        stroke={color ?? "#121219"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.4911 1.42542C12.8968 5.21627 12.967 12.4997 10.7016 16.4941"
        stroke={color ?? "#121219"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.125 9C17.125 4.51269 13.4873 0.875 9 0.875C4.51269 0.875 0.875 4.51269 0.875 9C0.875 13.4873 4.51269 17.125 9 17.125C13.4873 17.125 17.125 13.4873 17.125 9Z"
        stroke={color ?? "#121219"}
        strokeWidth="1.5"
      />
      <path
        d="M1.6875 5.75L16.3125 5.75"
        stroke={color ?? "#121219"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.6875 12.25L16.3125 12.25"
        stroke={color ?? "#121219"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  HelpCenter: (color?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.3307 10.0003C18.3307 5.39795 14.5998 1.66699 9.9974 1.66699C5.39502 1.66699 1.66406 5.39795 1.66406 10.0003C1.66406 14.6027 5.39502 18.3337 9.9974 18.3337C14.5998 18.3337 18.3307 14.6027 18.3307 10.0003Z"
        stroke={color ?? "white"}
        strokeWidth="2"
      />
      <path
        d="M7.91406 7.2657C8.02644 6.96937 8.19625 6.70376 8.409 6.48414C8.79859 6.08196 9.33216 5.83398 9.9207 5.83398C11.1137 5.83398 12.0807 6.85278 12.0807 8.10953C12.0807 9.18674 11.3702 10.0891 10.416 10.325C10.1479 10.3912 9.9207 10.6089 9.9207 10.8851V11.6673"
        stroke={color ?? "white"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.9974 15.2086C10.4576 15.2086 10.8307 14.8356 10.8307 14.3753C10.8307 13.9151 10.4576 13.542 9.9974 13.542C9.53716 13.542 9.16406 13.9151 9.16406 14.3753C9.16406 14.8356 9.53716 15.2086 9.9974 15.2086Z"
        fill={color ?? "white"}
      />
    </svg>
  ),

  Play: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
    >
      <path d="M2 4L22.9 15L2 26V4Z" fill="white" />
      <path
        d="M2.46575 3.11508L1 2.34364V4V26V27.6564L2.46575 26.8849L23.3657 15.8849L25.0471 15L23.3657 14.1151L2.46575 3.11508Z"
        stroke="black"
        strokeOpacity="0.15"
        strokeWidth="2"
      />
    </svg>
  ),
};
